// GpxFix SPA Application
(function () {
    'use strict';

    $(document).on('click', '#resetActivityLink', function (e) {
        e.preventDefault();
        if (window.gpxFixState.originalState) {
            var state = window.gpxFixState;
            // Restore state from original
            state.gpxXml = state.originalState.gpxXml;
            state.coordinates = state.originalState.coordinates;
            state.summary = state.originalState.summary;
            state.hasHeartRate = state.originalState.hasHeartRate;
            state.hasTime = state.originalState.hasTime;
            state.fileName = state.originalState.fileName;
            state.waypoints = state.originalState.waypoints;
            state.spikeZones = state.originalState.spikeZones;
            state.edits = []; // Clear edits

            // Update UI
            updateMap();
            initializeChart(state, 1);
            updateActivityInfo();

            // Hide reset link and show success message
            $(this).hide();
            showSuccess('Activity has been reset to its original state.');
            hideAllPanels();
        } else {
            showError('No original state available to reset to.');
        }
    });

    // ---- Application Insights error telemetry ----
    function getAppInsights() {
        // SDK v2 snippet exposes the instance via the configured name (default: appInsights)
        // Also handle cases where it's still initializing (queue object exists but trackException may not yet be bound)        
        var ai = window.ai || window.appInsights || (window.Microsoft && window.Microsoft.ApplicationInsights && window.Microsoft.ApplicationInsights.defaultClient);
        if (ai && typeof ai.trackException === 'function') {
            return ai;
        }
        return null;
    }
    function trackException(message, source, detail) {
        try {
            console.log('track exception: ' + message);
            var ai = getAppInsights();
            if (!ai) {
                console.warn('AppInsights not available:', message);
                return;
            }
            console.log('ai : ' + ai);
            if (ai && typeof ai.trackException === 'function') {
                console.log('ai ok ' + message + ' - ' + source + ' - ' + detail);
                ai.trackException({
                    exception: detail instanceof Error ? detail : new Error(message),
                    properties: { source: source || 'Spa.js', message: message }
                });
                console.log('ai ok 2'); 
            }
        } catch (e) {
            console.log('exception inside ai exception handling: ' + e);
            /* never let telemetry break the app */
        }
    }

    window.onerror = function (message, source, lineno, colno, error) {
        // Only track errors from our own scripts, ignore third-party (analytics, ads, CDNs, etc.)
        var ownOrigin = window.location.origin;
        if (source && !source.startsWith(ownOrigin)) {
            return false;
        }
        trackException(String(message), source + ':' + lineno + ':' + colno, error);
        return false; // let default browser handling continue
    };

    window.addEventListener('unhandledrejection', function (event) {
        var reason = event.reason;
        // Ignore rejections from third-party scripts by checking the stack origin
        if (reason instanceof Error && reason.stack) {
            var ownOrigin = window.location.origin;
            var stackLines = reason.stack.split('\n').filter(function (l) { return l.indexOf('://') !== -1; });
            var allExternal = stackLines.length > 0 && stackLines.every(function (l) { return l.indexOf(ownOrigin) === -1; });
            if (allExternal) return;
        }
        var msg = reason instanceof Error ? reason.message : String(reason);
        trackException('Unhandled promise rejection: ' + msg, 'unhandledrejection', reason instanceof Error ? reason : null);
    });



    // Use shared utilities
    // var utils = window.GpxFixUtils || {};
    var chartModule = window.GpxFixChart || {};

    // Application State - Global variable
    window.gpxFixState = {
        gpxXml: null,
        coordinates: null,
        summary: null,
        hasHeartRate: false,
        hasTime: false,
        fileName: null,
        isDebug: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
        stravaActivityId: null,
        activityMetadata: null,
        map: null,
        polyline: null,
        marker: null,
        chart: null,
        waypointMarkers: [], // Add waypointMarkers to state
        edits: [],
        origLatLngs: null,
        editMode: false,
        timezoneOffsetActivityLocation: null,
        // Comparison state
        compareMode: false,
        originalState: null,  // Store original activity for comparison
        compareState: null,   // Store comparison activity
        compareOrigLatLng1: null,
        compareOrigLatLng2: null,
        compareMap1: null,
        compareMap2: null,
        compareOverlayMap: null,
        compareChart1: null,
        compareChart2: null,
        compareViewMode: 'side-by-side',
        waypoints: null,
        isFirstLoad: false,
        // Spike-zone markers � GPS-erratic regions shown as ?? pins on the map
        spikeZones: null,
        spikeZoneMarkers: []
    };

    var state = window.gpxFixState;
    const COMPARE_TRACK_COLORS = {
        1: '#dc2b00',
        2: '#0066cc'
    };

    var API = {
        upload: '/api/gpx/upload',
        operation: '/api/gpx/operation',
        stravaActivities: '/api/activities/recent',
        stravaSave: '/api/activity/save',
        submitReview: '/api/gpx/submit-review'
    };

    // Outdoor activity types are inlined into the page by the server (see FunctionSpaPage.cs)
    // as the JS constant `outdoorActivityTypesData`, eliminating a separate API round-trip.
    var outdoorActivityTypes = (typeof outdoorActivityTypesData !== 'undefined' && Array.isArray(outdoorActivityTypesData))
        ? outdoorActivityTypesData
        : [];

    // Fast/safe parser for API array payloads. Server returns either a JSON string
    // or a JS literal that historically required eval(). Try JSON.parse first
    // (much faster, no script compilation, safe), fall back to eval for legacy payloads.
    function parseApiArray(payload) {
        if (payload == null) return null;
        if (typeof payload !== 'string') return payload;
        try {
            return JSON.parse(payload);
        } catch (e) {
            try {
                // eslint-disable-next-line no-eval
                return eval(payload);
            } catch (e2) {
                console.error('parseApiArray failed:', e2);
                return null;
            }
        }
    }

    async function uploadGpx(gpxData, isStravaActivity = false) {
        //showLoader();
        try {
            const headers = { 'Content-Type': isStravaActivity ? 'application/json' : 'text/plain' };
            if (!isStravaActivity && state.fileName) {
                // Encode filename to handle special characters properly in HTTP header
                headers['X-File-Name'] = encodeURIComponent(state.fileName);
            }

            const response = await fetch(API.upload, {
                method: 'POST',
                headers: headers,
                body: isStravaActivity ? JSON.stringify(gpxData) : gpxData
            });

            // Check if response is OK and has content before parsing JSON
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                state.isFirstLoad = true;
                updateState(result);

                // Store original activity state for reset functionality
                state.originalState = {
                    gpxXml: state.gpxXml,
                    coordinates: state.coordinates,
                    summary: state.summary,
                    hasHeartRate: state.hasHeartRate,
                    hasTime: state.hasTime,
                    fileName: state.fileName,
                    waypoints: state.waypoints,
                    spikeZones: state.spikeZones
                };

                showActivitySection();
                initializeMap();
                initializeChart(state, 1);
                showDownloadPanel();
                showTopWarning(result.warning);
                if (result.summary && result.summary.coordinatesCount === 0) {
                    showTopWarning("This activity had 0 track points and so we cant display a track. GpxFix was developed for outdoor activities. ");
                }
                if (result.spikeZones) {
                    showTopWarning("This track has sections with erratic GPS data, likely due to signal loss. Tracked distance may be longer than the actual distance covered. Consider cutting out erratic sections or editing trackpoints using the 'Edit coordinates' feature. ");
                    $('#btFixGps').addClass('btn-pulse');
                }
                if (result.message) {
                    showSuccess(result.message, result.additionalInfo);
                }
            } else {
                showError(result.message || 'Failed to upload GPX file.', result.additionalInfo);
                $('#file-input').val('');
            }
        } catch (error) {
            console.error('Upload error:', error);
            trackException('Upload error: ' + error.message, 'uploadGpx', error);
            showError('An error occurred while uploading the file.', '');
            $('#file-input').val('');
        } finally {
            hideLoaders();
            //$('#file-input').val('');
        }
    }

    function showTopWarning(message) {        
        const $messageTop = $('#message-top');
        if (!message) {
            //$messageTop.html('').hide();
            return;
        }

        $messageTop.append(`<span class='warning'>${escapeHtml(message)}</span>`).show();
    }

    // Upload GPX file for comparison
    async function uploadCompareGpx(gpxData, fileName) {
        try {
            const response = await fetch(API.upload, {
                method: 'POST',
                headers: { 'Content-Type': 'text/plain' },
                body: gpxData
            });

            // Check if response is OK and has content before parsing JSON
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                // Store original activity state before comparison
                state.originalState = {
                    gpxXml: state.gpxXml,
                    coordinates: state.coordinates,
                    summary: state.summary,
                    hasHeartRate: state.hasHeartRate,
                    hasTime: state.hasTime,
                    fileName: state.fileName
                };

                // Parse compare coordinates
                let compareCoordinates = parseApiArray(result.coordinates) || [];

                // Store comparison activity state
                state.compareState = {
                    gpxXml: result.gpxXml,
                    coordinates: compareCoordinates,
                    summary: result.summary,
                    hasHeartRate: result.hasHeartRate,
                    hasTime: result.hasTime,
                    fileName: fileName
                };

                // Enter comparison mode
                enterCompareMode();
            } else {
                showError(result.message || 'Failed to upload comparison GPX file.', result.additionalInfo);
            }
        } catch (error) {
            console.error('Compare upload error:', error);
            trackException('Compare upload error: ' + error.message, 'uploadCompareGpx', error);
            showError('An error occurred while uploading the comparison file.', '');
        } finally {
            hideLoaders();
        }
    }


    // Enter comparison mode - show side by side or overlayed view
    function enterCompareMode() {
        state.compareMode = true;
        hideAllPanels();
        debug('comparestate=');
        debug(state.compareState);
        // Hide normal activity section, show compare section
        $('#activity-section').hide();
        $('#action-menu').hide();
        $('#compare-section').show();
        $('#message-bottom').hide();
        $('#download-area').hide();

        $(`input[name="compareViewMode"][value="${state.compareViewMode}"]`).prop('checked', true);
        renderCompareView();
        window.GpxFixMap.addSliderSyncEventHandlersIfNotAdded();
    }

    function getCompareTrackColor(num) {
        return COMPARE_TRACK_COLORS[num] || COMPARE_TRACK_COLORS[1];
    }

    function getCompareViewMode() {
        const selectedMode = $('input[name="compareViewMode"]:checked').val();
        return selectedMode === 'overlay' ? 'overlay' : 'side-by-side';
    }

    function setCompareViewMode(mode) {
        state.compareViewMode = mode === 'overlay' ? 'overlay' : 'side-by-side';
        const isOverlayMode = state.compareViewMode === 'overlay';
        $('#compare-section').toggleClass('overlay-mode', isOverlayMode);
        $('#compare-overlay-map-section').toggle(isOverlayMode);
        $('.compare-side-map').toggle(!isOverlayMode);
    }

    function cleanupCompareMap(num) {
        const mapProp = num === 1 ? 'compareMap1' : 'compareMap2';
        if (state[mapProp]) {
            state[mapProp].remove();
            state[mapProp] = null;
        }
        state[`compareMarker${num}`] = null;
        state[`comparePolyline${num}`] = null;
    }

    function cleanupCompareOverlayMap() {
        if (state.compareOverlayMap) {
            state.compareOverlayMap.remove();
            state.compareOverlayMap = null;
        }
    }

    function cleanupCompareMaps() {
        cleanupCompareMap(1);
        cleanupCompareMap(2);
        cleanupCompareOverlayMap();
    }

    function renderCompareView() {
        if (!state.originalState || !state.compareState) return;

        cleanupCompareMaps();
        setCompareViewMode(getCompareViewMode());

        const renderSideMaps = state.compareViewMode !== 'overlay';
        renderCompareActivity(1, state.originalState, renderSideMaps);
        renderCompareActivity(2, state.compareState, renderSideMaps);

        if (state.compareViewMode === 'overlay') {
            initializeCompareOverlayMap();
        }
    }

    // Exit comparison mode
    function exitCompareMode() {
        state.compareMode = false;
        state.compareState = null;

        // Clean up compare maps and charts
        cleanupCompareMaps();
        if (state.compareChart1) {
            state.compareChart1.destroy();
            state.compareChart1 = null;
        }
        if (state.compareChart2) {
            state.compareChart2.destroy();
            state.compareChart2 = null;
        }

        // Clear file input
        $('#file-compare').val('');

        // Show normal activity section
        $('#compare-section').hide();
        $('#activity-section').show();
        $('#action-menu').show();
        $('#download-area').show();
    }

    // Render activity in comparison view
    function renderCompareActivity(num, activityState, renderMap) {
        if (!activityState) return;

        // Render summary info
        const infoHtml = buildCompareInfoHtml(activityState);
        $(`#compare-info-${num}`).html(infoHtml);

        if (renderMap) {
            initializeCompareMap(num, activityState);
        }

        // Initialize chart
        initializeCompareChart(num, activityState);

        // Setup slider
        const sliderEl = document.getElementById(`compare-slider-${num}`);
        if (sliderEl && activityState.coordinates) {
            sliderEl.max = activityState.coordinates.length - 1;
            sliderEl.value = 0;
        }
    }

    // Build HTML for compare activity info
    function buildCompareInfoHtml(activityState) {
        debug('buildCompareInfoHtml');
        if (!activityState.summary) return '';
        const s = activityState.summary;
        let html = '';


        if (s.name) {
            html += `<strong>Name:</strong> ${escapeHtml(s.name)}<br/>`;
        }
        if (s.description) {
            html += `<small>${escapeHtml(s.description)}</small><br/>`;
        }
        if (activityState.downloadLink) {
            html += `<small>${activityState.downloadLink}</small><br/>`;
        }
        else if (activityState.fileName) {
            html += `<small>${activityState.fileName.replace(/_/g, ' ')}</small><br/>`;
        }
        html += `<strong>Distance:</strong> ${formatDistance(s.totalMeters, useImperial)}<br/>`;
        if (s.elapsedTimeSeconds > 0) {
            html += `<strong>Elapsed time:</strong> ${formatTimeSpanFromSeconds(s.elapsedTimeSeconds)}<br/>`;
        }
        if (s.movingTimeSeconds > 0) {
            html += `<strong>Moving time:</strong> ${formatTimeSpanFromSeconds(s.movingTimeSeconds)}<br/>`;
        }
        if (s.maxHr > 0) {
            html += `<strong>HR:</strong> max ${s.maxHr}, avg ${Math.round(s.avgHr)} bpm<br/>`;
        }
        if (s.speedKmPerH > 0) {
            html += `<strong>Speed:</strong> ${s.speedKmPerH.toFixed(1)} km/h<br/>`;
        }
        if (s.elevationGainTotal > 0) {
            html += `<strong>Elevation gain:</strong> ${s.elevationGainTotal} m<br/>`;
        }
        if (s.startTimeUtc) {
            html += `<strong>Date:</strong> ${new Date(s.startTimeUtc).toLocaleDateString()}<br/>`;
        }
        html += `<strong>Track points:</strong> ${s.coordinatesCount}`;

        return html;
    }

    // Initialize map for comparison view
    function initializeCompareMap(num, activityState) {
        if (!activityState.coordinates || activityState.coordinates.length === 0) return;

        const mapId = `compare-map-${num}`;
        const mapEl = document.getElementById(mapId);
        if (!mapEl) return;

        // Remove existing map if any
        const mapProp = num === 1 ? 'compareMap1' : 'compareMap2';
        if (state[mapProp]) {
            state[mapProp].remove();
        }

        const map = L.map(mapId).setView([0, 0], 13);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 22,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        // Add track polyline
        const srcCoords = activityState.coordinates;
        const coords = new Array(srcCoords.length);
        for (let i = 0; i < srcCoords.length; i++) {
            const c = srcCoords[i];
            coords[i] = [c[0].lat, c[0].lon];
        }
        const trackColor = getCompareTrackColor(num);
        const polyline = L.polyline(coords, { color: trackColor, weight: 3 }).addTo(map);
        map.fitBounds(polyline.getBounds());

        // Add initial marker
        const firstCoord = activityState.coordinates[0];
        // pane: 'markerPane' (z=600) ensures the marker renders above the polyline (overlayPane z=400)
        const marker = L.circleMarker([firstCoord[0].lat, firstCoord[0].lon], {
            radius: 6,
            color: trackColor,
            fillColor: trackColor,
            fillOpacity: 1,
            opacity: 1,
            pane: 'markerPane'
        }).addTo(map);

        // Store map and marker reference
        state[mapProp] = map;
        state[`compareMarker${num}`] = marker;
        state[`comparePolyline${num}`] = polyline;

        debug('settings state.compareOrigLatLng');
        const origCoordsRaw = polyline.getLatLngs();
        const origCoords = origCoordsRaw.map(latlng => L.latLng(latlng.lat, latlng.lng));
        if (num == 1) {
            state.compareOrigLatLng1 = origCoords;
        } else {
            state.compareOrigLatLng2 = origCoords;
        }
    }

    function initializeCompareOverlayMap() {
        const mapEl = document.getElementById('compare-map-overlay');
        if (!mapEl || !state.originalState?.coordinates || !state.compareState?.coordinates) return;

        cleanupCompareOverlayMap();

        const map = L.map('compare-map-overlay').setView([0, 0], 13);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 22,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        const bounds = L.latLngBounds([]);
        renderOverlayTrack(map, bounds, 1, state.originalState);
        renderOverlayTrack(map, bounds, 2, state.compareState);

        if (bounds.isValid()) {
            map.fitBounds(bounds);
        }

        state.compareOverlayMap = map;
    }

    function renderOverlayTrack(map, bounds, num, activityState) {
        if (!activityState?.coordinates || activityState.coordinates.length === 0) return;

        const coords = [];
        const srcCoords = activityState.coordinates;
        for (let i = 0; i < srcCoords.length; i++) {
            const c = srcCoords[i];
            if (c && c[0]) {
                coords.push([c[0].lat, c[0].lon]);
            }
        }

        if (coords.length === 0) return;

        const trackColor = getCompareTrackColor(num);
        const polyline = L.polyline(coords, { color: trackColor, weight: 3 }).addTo(map);
        bounds.extend(polyline.getBounds());

        const firstCoord = coords[0];
        // pane: 'markerPane' (z=600) ensures the marker renders above the polyline (overlayPane z=400)
        const marker = L.circleMarker(firstCoord, {
            radius: 6,
            color: trackColor,
            fillColor: trackColor,
            fillOpacity: 1,
            opacity: 1,
            pane: 'markerPane'
        }).addTo(map);

        state[`compareMarker${num}`] = marker;
        state[`comparePolyline${num}`] = polyline;

        const origCoords = polyline.getLatLngs().map(latlng => L.latLng(latlng.lat, latlng.lng));
        if (num === 1) {
            state.compareOrigLatLng1 = origCoords;
        } else {
            state.compareOrigLatLng2 = origCoords;
        }
    }

    // Initialize chart for comparison view - uses shared chart module
    function initializeCompareChart(num, activityState) {
        var canvasId = 'compare-chart-' + num;
        var ctx = document.getElementById(canvasId);
        if (!ctx) return;

        var chartProp = num === 1 ? 'compareChart1' : 'compareChart2';
        if (state[chartProp]) {
            state[chartProp].destroy();
        }

        if (!activityState.coordinates || activityState.coordinates.length === 0) {
            ctx.style.display = 'none';
            return;
        }

        // Use shared chart module - pluginId 2 and 3 for compare charts to avoid conflict with main chart
        var pluginId = num + 1;
        state[chartProp] = chartModule.createChart(canvasId, activityState.coordinates, activityState.hasHeartRate, pluginId);
    }

    // Update marker position in compare mode
    function updateCompareMarker(num, idx) {
        const activityState = num === 1 ? state.originalState : state.compareState;
        const marker = state[`compareMarker${num}`];

        if (!activityState?.coordinates || !marker) return;

        if (idx >= 0 && idx < activityState.coordinates.length) {
            const coord = activityState.coordinates[idx];
            marker.setLatLng([coord[0].lat, coord[0].lon]);
        }
    }

    async function executeOperation(operation, params = {}) {
        debug('executeOperation');
        if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1' && typeof gtag === 'function') {
            gtag('event', operation);
        }
        var success = false;
        if (!state.gpxXml) {
            showUploadFileMessage();
            return;
        }
        $('#message-top').html(''); //clear messages
        scrollToBottomMessage();
        showLoader();
        hideAllPanels();

        try {
            const requestBody = {
                gpxXml: state.gpxXml,
                operation: operation,
                //timezoneOffsetActivityLocation: state.timezoneOffsetActivityLocation,
                stravaActivityId: state.stravaActivityId,
                fileName: state.fileName,
                activityName: $('#activityName').val() || '',
                activityDescription: $('#activityDesc').val() || '',
                ...params
            };

            const response = await fetch(API.operation, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });
            const result = await response.json();
            $('#message-top').html('');
            if (result.success) {
                state.isFirstLoad = false;
                // Reset review submission flag when a new operation is performed
                state.reviewSubmitted = false;
                // Check if HR fix options require user selection
                if (result.hrFixOptions && result.hrFixOptions.requiresUserSelection) {
                    // pass original params so we can preserve things like hrIssueType when the user
                    // must choose between groups A/B
                    showHrFixOptions(result.hrFixOptions, result.message, result.additionalInfo, params);
                    hideLoaders();
                    return true;
                }

                updateState(result);
                updateMap(); //updateMap(operation == "fixgps"); //if updateabounds needed
                initializeChart(state, 1);
                updateActivityInfo();
                showSuccess(result.message || 'Operation completed successfully.', result.additionalInfo);
                showDownloadPanel();
                // Track the completed operation toward the monthly donation prompt.
                if (typeof window.trackOperationForDonation === 'function') {
                    window.trackOperationForDonation();
                }
                success = true;
            } else {
                showError(result.message || 'Operation failed.', result.additionalInfo);
            }
        } catch (error) {
            console.error('Operation error:', error);
            trackException('Operation error [' + operation + ']: ' + error.message, 'executeOperation', error);
            showError('An error occurred while processing the operation.');
        } finally {
            hideLoaders();
            $('#resetActivityLink').show();
            $('#file-restore-ref').val('');
            $('#file-smoothen-ref').val('');
            $('#div-smoothen-ref-upload').hide();
            // Reset radio selection back to basic after the operation completes
            $('input[name="radioSmoothenGps"][value="reference"]').prop('checked', false);
            $('input[name="radioSmoothenGps"][value="basic"]').prop('checked', true);
            return success;
        }
    }

    // Show HR fix options panel for user selection
    function showHrFixOptions(hrFixOptions, message, additionalInfo, originalParams) {
        hideAllPanels();
        hideLoaders();
        let html = '<div id="hrFixConfirm">';
        html += '<p>' + (message || 'Found potential HR measurement errors.') + '</p>';
        html += '<p>' + (additionalInfo || 'Two groups of measurements have similar effort yet HR is very different.') + '</p>';

        if (hrFixOptions.groups && hrFixOptions.groups.length >= 2) {
            const groupA = hrFixOptions.groups[0];
            const groupB = hrFixOptions.groups[1];

            html += '<p><strong>Group A averages:</strong><br/>' + groupA.description + '</p>';
            html += '<p><strong>Group B averages:</strong><br/>' + groupB.description + '</p>';
            html += '<p>Please choose A or B as the correct HR values and we will adjust the incorrect measurements.</p>';
            html += '<div id="hrFixButtons">';
            html += '<button class="submitHrFix" data-group="a" type="button">Use Group A</button> ';
            html += '<button class="submitHrFix" data-group="b" type="button">Use Group B</button> ';
            html += '<button id="cancelHrFix" type="button">Cancel</button>';
            html += '</div>';
        }

        html += '</div>';

        $('#panel-fixhr').html(html).show();

        // Bind event handlers
        $('.submitHrFix').off('click').on('click', function () {
            const group = $(this).data('group');
            $('#panel-fixhr').hide();
            // merge original params (may contain hrIssueType) with the selected group
            const paramsToSend = Object.assign({}, originalParams || {}, { hrCorrectToGroup: group });
            executeOperation('fixhr', paramsToSend);
        });

        $('#cancelHrFix').off('click').on('click', function () {
            $('#panel-fixhr').hide();
            showMessage('HR fix cancelled.', '');
        });
    }

    async function uploadCombineGpx(gpxData, fileName) {
        try {
            const response = await fetch(API.upload, {
                method: 'POST',
                headers: { 'Content-Type': 'text/plain' },
                body: gpxData
            });

            // Check if response is OK and has content before parsing JSON
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                // Store original activity state before comparison
                state.originalState = {
                    gpxXml: state.gpxXml,
                    coordinates: state.coordinates,
                    summary: state.summary,
                    hasHeartRate: state.hasHeartRate,
                    hasTime: state.hasTime,
                    fileName: state.fileName
                };

            } else {
                showError(result.message || 'Failed to upload comparison GPX file.', result.additionalInfo);
            }
        } catch (error) {
            console.error('Combine upload error:', error);
            showError('An error occurred while uploading the combine file.', '');
        } finally {
            hideLoaders();
        }
    }

    async function saveToStrava() {
        if (!state.gpxXml) {
            showError('No GPX data to save.');
            return;
        }

        showLoader();
        $('#btn-save-strava').prop('disabled', true).text('Saving...');

        try {
            const postData = {
                gpx: state.gpxXml,
                name: $('#activityName').val() || state.summary?.name || 'Activity',
                description: $('#activityDesc').val() || '',
                commute: state.activityMetadata?.commute || false,
                trainer: state.activityMetadata?.trainer || false,
                gear: state.activityMetadata?.gearId || '',
                hideFromHome: state.activityMetadata?.hideFromHome || false,
                'private': state.activityMetadata?.isPrivate || false,
                sport_type: getSelectedSportTypeForSave()
            };

            let url = API.stravaSave;
            if (state.stravaActivityId) {
                url += '?activityId=' + state.stravaActivityId;
            }

            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData)
            });
            const result = await response.json();

            if (result.statuscode === 1) {
                showSuccess('Activity successfully saved to Strava', result.message);
            } else {
                showError('Unable to save to Strava', result.message);
            }
        } catch (error) {
            console.error('Save to Strava error:', error);
            trackException('Save to Strava error: ' + error.message, 'saveToStrava', error);
            showError('An error occurred while saving to Strava.');
        } finally {
            hideLoaders();
            $('#btn-save-strava').prop('disabled', false).text('Save to Strava');
        }
    }

    async function submitActivityForReview() {
        // Always submit the ORIGINAL file (before any modifications), not the modified one.
        // This allows the team to analyze what the user started with and what they expected fixed.
        const gpxToSubmit = (state.originalState && state.originalState.gpxXml) 
            ? state.originalState.gpxXml 
            : state.gpxXml;

        const fileNameToSubmit = (state.originalState && state.originalState.fileName)
            ? state.originalState.fileName
            : state.fileName;

        if (!gpxToSubmit) {
            showError('No GPX data to submit.');
            return;
        }

        showLoader('loader-review-modal');
        $('#btn-confirm-review').prop('disabled', true).text('Submitting...');
        $('#btn-cancel-review').prop('disabled', true);

        try {
            const postData = {
                gpxXml: gpxToSubmit,
                fileName: fileNameToSubmit || 'activity.gpx',
                description: $('#review-description').val() || '',
                edits: state.edits || []
            };

            const response = await fetch(API.submitReview, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData)
            });
            const result = await response.json();

            if (result.success) {
                showSuccess('Activity submitted for review', 'Thank you for helping improve GpxFix!');
                $('#review-modal').hide();
                $('#review-description').val('');

                // Hide the submit for review button until a new operation is performed
                $('#btn-submit-review').hide();

                // Mark that review has been submitted for this activity
                state.reviewSubmitted = true;
            } else {
                showError('Unable to submit activity', result.message || 'An error occurred');
            }
        } catch (error) {
            console.error('Submit for review error:', error);
            trackException('Submit for review error: ' + error.message, 'submitActivityForReview', error);
            showError('An error occurred while submitting the activity.');
        } finally {
            hideLoaders();
            $('#btn-confirm-review').prop('disabled', false).text('Submit for Review');
            $('#btn-cancel-review').prop('disabled', false);
        }
    }

    async function loadStravaActivities() {
        showLoader('loader-activity');
        try {
            const response = await fetch(API.stravaActivities);
            if (response.status === 401) {
                showError('Please login with Strava to access your activities.');
                return;
            }
            const activities = await response.json();
            displayStravaActivities(activities);
        } catch (error) {
            console.error('Load activities error:', error);
            showError('Failed to load Strava activities.');
        } finally {
            hideLoaders();
        }
    }

    function updateState(result) {
        //debug('updateState:');
        //debug(result);
        state.gpxXml = result.gpxXml || state.gpxXml;
        // Parse coordinates (prefer JSON.parse over eval for performance and safety)
        const coordinatesJson = parseApiArray(result.coordinates);
        if (coordinatesJson) {
            state.coordinates = coordinatesJson;
        }

        // Parse waypoints
        if (result.waypoints) {
            const waypoints = parseApiArray(result.waypoints);
            if (waypoints) state.waypoints = waypoints;
        }

        // Parse spike zones � GPS-erratic regions to display as warning markers on the map.
        // The server sends a compact JSON array or null when no zones were found.
        if (result.spikeZones) {
            try {
                state.spikeZones = JSON.parse(result.spikeZones);
            } catch (e) {
                console.warn('Failed to parse spike zones:', e);
                state.spikeZones = null;
            }
        } else {
            state.spikeZones = null;
        }

        state.summary = result.summary || state.summary;
        state.downloadLink = result.downloadLink;
        state.hasHeartRate = result.hasHeartRate ?? state.hasHeartRate;
        state.hasTime = result.hasTime ?? state.hasTime;
        state.fileName = result.fileName || state.fileName || state.summary.fileName;
        state.stravaActivityId = result.stravaActivityId || state.stravaActivityId;
        state.activityMetadata = result.activityMetadata || state.activityMetadata;
        state.hasTimeCodes = state.coordinates && state.coordinates[0][2] != null;

        // Non-moving end button visibility is refreshed lazily when the crop panel
        // is opened (via the 'panelShown' event), so no update is needed here.
    }

    function haversineMeters(lat1, lon1, lat2, lon2) {
        const R = 6371000;
        const toRad = Math.PI / 180;
        const dLat = (lat2 - lat1) * toRad;
        const dLon = (lon2 - lon1) * toRad;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function computeKmSplits(coordinates, imperial) {
        if (!coordinates || coordinates.length < 2) return [];
        const splits = [];
        let cumulativeDist = 0;
        const KM = imperial ? 1609.344 : 1000;
        let nextSplitDist = KM;
        let splitStartIndex = 0;
        let splitStartTimeMs = coordinates[0][2] ? new Date(coordinates[0][2]).getTime() : null;
        let splitStartEle = coordinates[0][3];

        for (let i = 1; i < coordinates.length; i++) {
            const prev = coordinates[i - 1];
            const curr = coordinates[i];
            if (!prev[0] || !curr[0]) continue;
            const d = haversineMeters(prev[0].lat, prev[0].lon, curr[0].lat, curr[0].lon);
            const segmentStartDist = cumulativeDist;
            cumulativeDist += d;

            while (cumulativeDist >= nextSplitDist) {
                const ratio = d > 0 ? Math.min(1, Math.max(0, (nextSplitDist - segmentStartDist) / d)) : 1;
                const prevTimeMs = prev[2] ? new Date(prev[2]).getTime() : null;
                const currTimeMs = curr[2] ? new Date(curr[2]).getTime() : null;
                const splitEndTimeMs = (prevTimeMs != null && currTimeMs != null) ? prevTimeMs + ((currTimeMs - prevTimeMs) * ratio) : null;
                const splitEndEle = (prev[3] != null && curr[3] != null) ? prev[3] + ((curr[3] - prev[3]) * ratio) : null;
                const durationSec = (splitStartTimeMs != null && splitEndTimeMs != null) ? (splitEndTimeMs - splitStartTimeMs) / 1000 : null;
                const elevDiff = (splitStartEle != null && splitEndEle != null) ? Math.round(splitEndEle - splitStartEle) : null;
                splits.push({
                    km: splits.length + 1,
                    durationSec: (durationSec != null) ? durationSec / (KM / 1000) : null,
                    elevDiff: (elevDiff != null && imperial) ? Math.round(elevDiff * 3.28084) : elevDiff,
                    startIndex: splitStartIndex
                });
                splitStartIndex = i;
                splitStartTimeMs = splitEndTimeMs;
                splitStartEle = splitEndEle;
                nextSplitDist += KM;
            }
        }

        // Last partial segment
        const partialDist = cumulativeDist - (nextSplitDist - KM);
        if (partialDist > 50) {
            const segEnd = coordinates[coordinates.length - 1];
            const endTimeMs = segEnd[2] ? new Date(segEnd[2]).getTime() : null;
            const durationSec = (splitStartTimeMs != null && endTimeMs != null) ? (endTimeMs - splitStartTimeMs) / 1000 : null;
            const distKm = partialDist / 1000;
            const adjustedDuration = (durationSec && distKm > 0) ? durationSec / distKm : null;
            const endEle = segEnd[3];
            const elevDiffRaw = (splitStartEle != null && endEle != null) ? Math.round(endEle - splitStartEle) : null;
            const elevDiff = (elevDiffRaw != null && imperial) ? Math.round(elevDiffRaw * 3.28084) : elevDiffRaw;
            splits.push({
                km: splits.length + 1,
                durationSec: adjustedDuration,
                elevDiff: elevDiff,
                partial: true,
                partialKm: distKm,
                startIndex: splitStartIndex
            });
        }

        return splits;
    }

    function showActivitySection() {        
        $('.welcome-section').hide();
        $('#activity-section').show();
        updateActivityInfo();
    }

    /// <summary>
    /// Inspects the selected activity type against the track's average speed and, when they
    /// clearly disagree, appends a non-blocking warning suggesting the user change the type.
    /// Only wheel-vs-foot mismatches are flagged, which are the most reliably detectable from speed.
    /// </summary>
    function showActivityTypeMismatchWarning(activityType, s) {
        // Only evaluate on the initial load and when we have a meaningful moving speed to reason about.
        if (!state.isFirstLoad) return;
        if (!activityType || activityType === 'Not set') return;
        if (!s || !(s.speedKmPerH > 0)) return;

        // Require a reasonable amount of data so a few stray points cannot trigger a false warning.
        if (!(s.totalMeters >= 1000) || !(s.elapsedTimeSeconds >= 120)) return;

        const type = activityType.toLowerCase();
        const avgSpeed = s.speedKmPerH;      // average moving speed in km/h
        const maxSpeed = s.maxSpeedKmPerH || 0;

        // Classify the currently selected type into a broad movement category.
        const isFootType = type.includes('run') || type.includes('walk') || type.includes('hike');
        const isRideType = type.includes('ride') || type.includes('cycl') || type.includes('bike') || type.includes('ebike');

        let suggestion = '';

        // Foot activity (run/walk/hike) but speed is far too high to be on foot -> likely a ride.
        // Sustained average above ~17 km/h (or a very high max) is implausible for running/walking.
        if (isFootType && (avgSpeed > 17 || (maxSpeed > 35 && avgSpeed > 14))) {
            suggestion = 'Cycling';
        }
        // Ride activity but speed is low enough that it looks like walking/running on foot.
        else if (isRideType && avgSpeed < 9 && maxSpeed < 18) {
            suggestion = 'Running or Walking';
        }

        if (suggestion) {
            $('#message-top').append(
                `<span class='warning'>This activity is set to <strong>${escapeHtml(activityType)}</strong> but the average speed is ${avgSpeed.toFixed(1)} km/h, which looks more like <strong>${suggestion}</strong>. Please change your activity type or we will not be able to fix your activity.</span>`
            ).show();
        }
    }

    function updateActivityInfo() {
        if (!state.summary) return;
        const s = state.summary;
        let nameDescFields= `
            <input id='activityName' type='text' placeholder='Title'/>
            <textarea id='activityDesc' rows='3' placeholder='Description'>${escapeHtml(s.description || '')}</textarea>
            `;

        if (state.downloadLink) {
            nameDescFields += `<div><small>${state.downloadLink}</small></div>`;
        }
        else if (state.fileName) {
            nameDescFields += `<div><small>${state.fileName.replace(/_/g, ' ')}</small></div>`;
        }


        let statsHtml = ``;
        const activityType = s.sportType || state.activityMetadata?.sportType || 'Not set';
        statsHtml += `<strong>Activity type:</strong> <span id='activity-type-display'>${escapeHtml(activityType)}</span> `;
        // Render a compact icon-button that opens the native <select> dropdown.
        // The select is visually hidden but positioned over the button so clicking the
        // icon triggers the browser's native dropdown without any custom popup logic.
        statsHtml += `<span class='sport-type-picker' title='Override the Strava activity type'>`;
        statsHtml += `  <button type='button' class='btn-sport-type-icon' aria-label='Change activity type'>&#9660;</button>`;
        statsHtml += `  <select id='select-sport-type' class='select-sport-type' aria-label='Override the Strava activity type (optional)'></select>`;
        statsHtml += `</span><br/>`;


        statsHtml += `<strong>Distance:</strong> ${formatDistance(s.totalMeters, useImperial)}<br/>`;


        if (s.elapsedTimeSeconds > 0) {
            statsHtml += `<strong>Elapsed time:</strong> ${formatTimeSpanFromSeconds(s.elapsedTimeSeconds)} <br />`;
        }

        if (s.movingTimeSeconds > 0) {
            statsHtml += `<strong>Moving time:</strong> ${formatTimeSpanFromSeconds(s.movingTimeSeconds)}<br/>`;
        }

        if (s.maxHr > 0) {
            statsHtml += `<strong>Heart rate:</strong> max ${s.maxHr}, avg ${Math.round(s.avgHr)} bpm<br/>`;
        }

        if (s.speedKmPerH > 0) {
            statsHtml += `<strong>Speed:</strong> ${useImperial ? (s.speedKmPerH * 0.621371).toFixed(1) + ' mph' : s.speedKmPerH.toFixed(1) + ' km/h'} `;
            statsHtml += `<strong>Pace:</strong> ${formatPace(s.speedKmPerH)}<br/>`;
        }

        if (s.maxSpeedKmPerH > 0) {
            //html += `<strong>Max speed:</strong> ${s.maxSpeedKmPerH.toFixed(1)} km/h<br/>`;
            statsHtml += `<strong>Max speed:</strong> ${useImperial ? (s.maxSpeedKmPerH * 0.621371).toFixed(1) + ' mph' : s.maxSpeedKmPerH.toFixed(1) + ' km/h'} <strong>Pace:</strong> ${formatPace(s.maxSpeedKmPerH)}</strong> <span style='top:-1px' class='help-icon' data-tooltip='The highest average speed recorded during any 3-second interval of the activity'>?</span><br/>`;
        }

        if (s.elevationGainTotal > 0) {
            statsHtml += `<strong>Elevation gain:</strong> ${s.elevationGainTotal} m<br/>`;
        }

        if (s.avgCad > 0) {
            statsHtml += `<strong>Cadence:</strong> avg ${Math.round(s.avgCad)} rpm (Max ${Math.round(s.maxCad)})<br/>`;
        }

        if (s.avgPower > 0) {
            statsHtml += `<strong>Power:</strong> avg ${Math.round(s.avgPower)} W (Max ${Math.round(s.maxPower)})<br/>`;
        }

        if (s.avgTemp > 0) {
            statsHtml += `<strong>Temperature:</strong> avg ${Math.round(s.avgTemp)}°C (Min ${Math.round(s.minTemp)}°C, Max ${Math.round(s.maxTemp)}°C)<br/>`;
        }
        //debug('s.startTimeUtc=' + s.startTimeUtc);
        //debug('state.timezoneOffsetActivityLocation=' + s.timezoneOffsetActivityLocation);
        //debug('browserTimezoneOffset=' + browserTimezoneOffset);

        const localStartTimeAtActivity = addHours(s.startTimeUtc, s.timezoneOffsetActivityLocation);
        const localStartTimeAtActivityBrowserAdjusted = addHours(localStartTimeAtActivity, browserTimezoneOffset);

        const localEndTimeAtActivity = addHours(s.endTimeUtc, s.timezoneOffsetActivityLocation);
        const localEndTimeAtActivityBrowserAdjusted = addHours(localEndTimeAtActivity, browserTimezoneOffset);

        if (s.startTimeUtc) {
            statsHtml += `<strong>Start time:</strong> ${formatTime(localStartTimeAtActivityBrowserAdjusted, true)}<br/>`;
        }

        if (s.endTimeUtc && s.startTimeUtc) {
            if (s.endTimeUtc != s.startTimeUtc)
                statsHtml += `<strong>End time:</strong> ${formatTime(localEndTimeAtActivityBrowserAdjusted, true)}<br/>`;
        }

        statsHtml += `<strong>Track points:</strong> ${s.coordinatesCount} `;
        if (s.coordinatesCount > 1 && s.elapsedTimeSeconds > 0) {            
            statsHtml += `Recording interval: ${(s.trackingInterval).toFixed(1)} s`;
        }

        if (s.linkHref && !s.linkText) { //has link but no link text            
            const linkLabel = escapeHtml(s.linkHref.length > 60 ? s.linkHref.substring(0, 60) + '...' : s.linkHref);
            statsHtml += `<br/><small><strong>Link:</strong> <a href='${escapeHtml(s.linkHref)}' target='_blank' rel='noopener noreferrer'>${linkLabel}</a></small>`;
        }
        else if (s.linkHref && s.linkText && !s.linkText.includes("gpxfix")) {
            const linkLabel = escapeHtml(s.linkText);
            statsHtml += `<span class='hideOnSmallScreen'><br/><small><strong>Link:</strong> <a href='${escapeHtml(s.linkHref)}' target='_blank' rel='noopener noreferrer'>${linkLabel}</a></small></span>`;
        }

        if (s.creator && !s.creator.toLowerCase().includes("gpxfix")) {
            statsHtml += `<span class='hideOnSmallScreen'><br/><small><strong>Creator:</strong> ${escapeHtml(s.creator)}</small></span>`;
        }

        if (s.copyrightInfo && !s.copyrightInfo.includes("gpxfix")) {
            statsHtml += `<span class='hideOnSmallScreen'><br/><small><strong>Copyright:</strong> ${escapeHtml(s.copyrightInfo)}</small>`;
        }

        // Build splits HTML
        let splitsHtml = '';
        if (state.coordinates && state.coordinates.length > 1 && s.totalMeters >= 2000) {
            const splits = computeKmSplits(state.coordinates, useImperial);
            if (splits.length > 0) {
                const hasTime = splits.some(sp => sp.durationSec != null && sp.durationSec !== 0);
                const hasEle = splits.some(sp => sp.elevDiff != null && sp.elevDiff !== 0);

                if (hasTime || hasEle) {
                    const scrollOpen = splits.length > 13 ? '<div style="max-height:280px;overflow-y:auto">' : '';
                    const scrollClose = splits.length > 13 ? '</div>' : '';
                    const splitDistUnit = useImperial ? 'mi' : 'km';
                    const elevUnit = useImperial ? 'ft' : 'm';

                    // Find fastest and slowest splits (excluding partial splits)
                    let fastestIdx = -1;
                    let slowestIdx = -1;
                    if (hasTime) {
                        const fullSplits = splits.filter((sp, idx) => !sp.partial && sp.durationSec != null).map((sp, _, arr) => {
                            const origIdx = splits.findIndex(s => s === sp);
                            return { idx: origIdx, pace: sp.durationSec };
                        });
                        if (fullSplits.length >= 2) {
                            fullSplits.sort((a, b) => a.pace - b.pace);
                            fastestIdx = fullSplits[0].idx;
                            slowestIdx = fullSplits[fullSplits.length - 1].idx;
                        }
                    }

                    splitsHtml += `<strong>Splits</strong>`;
                    splitsHtml += scrollOpen;
                    splitsHtml += `<table class='splits-table' id='splits-table'><thead><tr><th data-sort="float">${splitDistUnit}</th>${hasTime ? '<th data-sort="float">Pace</th>' : ''}${hasEle ? '<th data-sort="int">Elev</th>' : ''}</tr></thead><tbody>`;
                    for (let i = 0; i < splits.length; i++) {
                        const sp = splits[i];
                        const partialDist = useImperial ? (sp.partialKm * 0.621371) : sp.partialKm;
                        const label = sp.partial ? partialDist.toFixed(2) : sp.km;
                        let rowClass = '';
                        if (i === fastestIdx) rowClass = ' class="fastest-split"';
                        else if (i === slowestIdx) rowClass = ' class="slowest-split"';

                        let paceCell = '';
                        let paceValue = '';
                        if (hasTime) {
                            if (sp.durationSec != null) {
                                const paceSecPerUnit = useImperial ? sp.durationSec / 0.621371 : sp.durationSec;
                                const paceMin = Math.floor(paceSecPerUnit / 60);
                                const paceSec = Math.round(paceSecPerUnit % 60);
                                paceValue = paceSecPerUnit.toFixed(2);
                                paceCell = `<td data-sort-value="${paceValue}">${paceMin}:${String(paceSec).padStart(2, '0')} <small>/${splitDistUnit}</small></td>`;
                            } else {
                                paceCell = '<td data-sort-value="999999">-</td>';
                            }
                        }
                        let eleCell = '';
                        if (hasEle) {
                            if (sp.elevDiff != null) {
                                eleCell = `<td data-sort-value="${sp.elevDiff}">${sp.elevDiff}<small>${elevUnit}</small></td>`;
                            } else {
                                eleCell = '<td data-sort-value="0">-</td>';
                            }
                        }
                        // For partial splits, use a very high sort value (999999) to ensure they always sort last
                        const distValue = sp.partial ? 999999 : sp.km;
                        splitsHtml += `<tr${rowClass} data-start-index="${sp.startIndex}"><td data-sort-value="${distValue}">${label}</td>${paceCell}${eleCell}</tr>`;
                    }
                    splitsHtml += '</tbody></table>';
                    splitsHtml += scrollClose;
                }
            }
        }
        const startOverHtml = `<p id='start-over-section'><a href='/' id='btn-start-over' title='Start over by choosing a different activity/workout'>Open another activity</a><a href='#' id='resetActivityLink' title='Start over by resetting current activity back to its original state'>Reset activity</a></p>`;
        const html = `<div>${nameDescFields}</div><div class='activity-info-row'><div class='activity-stats'>${statsHtml} ${startOverHtml}</div>${splitsHtml ? `<div class='activity-splits'>${splitsHtml}</div>` : ''}</div>`;
        $('#activity-info').html(html);
        $('#activityName').val(s.name);
        populateSportTypeDropdown();

        const isRunning = activityType.toLowerCase().includes('run');       
        if (state.isFirstLoad && isRunning && (s.maxSpeedKmPerH > 30 || (s.maxSpeedKmPerH > 25 && s.totalMeters > 5000))) {
            $('#message-top').append(`<span class='warning'>Max speed of ${s.maxSpeedKmPerH.toFixed(1)} km/h detected. If this looks too high, consider using 'Fix GPS issues' or 'Crop/cut' to remove speed spikes. </span>`).show();
            $('#btFixGps').addClass('btn-pulse');            
        } else if (state.isFirstLoad && state.spikeZones && state.spikeZones.length > 0) {
            // Spike zones detected - highlight Fix GPS button
            $('#btFixGps').addClass('btn-pulse');
        } else {
            $('#btFixGps').removeClass('btn-pulse');
            $('#message-top').html('');
        }

        if (state.isFirstLoad && s.coordinatesCount > 1 && s.elapsedTimeSeconds > 20 && s.trackingInterval > 1.5 && s.avgHr > 131 && s.speedKmPerH > 10 && s.elapsedTimeSeconds < 5400) {
            $('#message-top').append(`<span class='warning'>Recording interval is ${s.trackingInterval.toFixed(1)}s. Consider changing the measurement interval settings on your device to capture more precise data.</span>`).show();
        }

        // Warn the user if the chosen activity type does not match the average speed of the track.
        // Average speed is a reliable signal for distinguishing foot-based activities (walk/run)
        // from wheel-based ones (ride/cycling). This helps catch cases where the device or import
        // tagged the activity with the wrong sport type.
        showActivityTypeMismatchWarning(activityType, s);

        if (typeof bindTooltips === 'function') bindTooltips();

        // Setup table sorting for splits table
        const splitsTable = document.getElementById('splits-table');
        if (splitsTable && typeof $ !== 'undefined' && $.fn.stupidtable) {
            $('#splits-table').stupidtable();
        }

        $('#activity-info').on('click', '#splits-table tbody tr', function () {
            const startIndex = $(this).data('start-index');
            if (startIndex !== undefined) {
                $('#timeSlider').val(startIndex).trigger('input');
            }
        });

        $('#resetActivityLink').on('click', function () {
            //debug('resetActivityLink');
            //debug('state.fileName=' + state.fileName);
            showLoader();
            if (state.stravaActivityId) {
                uploadGpx({ stravaActivityId: state.stravaActivityId, timezoneOffsetActivityLocation: state.timezoneOffsetActivityLocation }, true);
            } else if (state.fileName) {
                const fileInput = document.querySelector('#file-input');
                //debug('fileInput=');
                //debug(fileInput);
                if (fileInput && fileInput.files.length > 0) {
                    const file = Array.from(fileInput.files).find(f => f.name === state.fileName);
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = function (e) {
                            uploadGpx(e.target.result);
                        };
                        reader.readAsText(file);
                    } else {
                        showError('File "${state.fileName}" not found in the file input.');
                    }
                } else {
                    showError('No file input available or no files selected.');
                }
            } else {
                showError('Not able to reset current activity.');
            }
        });
    }

    function displayStravaActivities(activities) {
        const $section = $('#strava-activities-section');
        const $table = $('#strava-activities');
        $table.empty();

        if (!activities || activities.length === 0) {
            $table.html('<p>No activities found.</p>');
            $section.show();
            return;
        }

        let html = '<thead><tr><th data-sort="date">Date</th><th data-sort="string">Title</th><th data-sort="distance">Distance</th><th data-sort="time">Moving time</th></tr></thead><tbody>';
        activities.forEach(activity => {
            const startDate = new Date(activity.start_date_local);
            const dateStr = startDate.toLocaleDateString() + ' ' + startDate.toLocaleTimeString();
            const distance = (activity.distance / 1000).toFixed(2) + ' km';
            const time = formatTimeSpanFromSeconds(activity.moving_time);

            if (activity.distance > 1 && activity.start_latlng && activity.start_latlng[0]) {
                const startDate = new Date(activity.start_date_local);
                const startDateFormatted = startDate.toLocaleDateString() + ' ' + startDate.toLocaleTimeString();
                html += `<tr class='activity-row' data-id='${activity.id}' title='${startDateFormatted}'>
                    <td>${dateStr}</td>
                    <td class='name'>${escapeHtml(activity.name)}</td>
                    <td>${distance}</td>
                    <td>${time}</td>
                </tr>`;
            }
        });
        html += '</tbody>';
        $table.html(html);
        $section.show();

        $('#strava-activities').stupidtable(stupidTableSortFunctions);

        // Bind click handlers
        $('.activity-row').on('click', function () {
            const activityId = $(this).data('id');
            $section.hide();
            showLoader('loader-activity');
            uploadGpx({ stravaActivityId: activityId.toString(), timezoneOffsetActivityLocation: state.timezoneOffsetActivityLocation }, true);
        });
    }

    async function loadStravaActivitiesForComparison() {
        showLoader();
        try {
            const response = await fetch(API.stravaActivities);
            if (response.status === 401) {
                showError('Please login with Strava to access your activities.');
                return;
            }
            const activities = await response.json();
            displayStravaActivitiesForComparison(activities);
        } catch (error) {
            console.error('Load activities for comparison error:', error);
            showError('Failed to load Strava activities.');
        } finally {
            hideLoaders();
        }
    }

    // Display Strava activities for comparison selection
    function displayStravaActivitiesForComparison(activities) {
        const $section = $('#my-activities-section');
        const $table = $('#my-activities');
        $table.empty();

        if (!activities || activities.length === 0) {
            $table.html('<p>No activities found.</p>');
            $section.show();
            return;
        }

        let html = '<thead><tr><th data-sort="date">Date</th><th data-sort="string">Title</th><th data-sort="distance">Distance</th><th data-sort="time">Moving time</th></tr></thead><tbody>';
        activities.forEach(activity => {
            const startDate = new Date(activity.start_date_local);
            const dateStr = startDate.toLocaleDateString() + ' ' + startDate.toLocaleTimeString();
            const distance = (activity.distance / 1000).toFixed(2) + ' km';
            const time = formatTimeSpanFromSeconds(activity.moving_time);

            if (activity.distance > 1 && activity.start_latlng && activity.start_latlng[0]) {
                const startDateFormatted = startDate.toLocaleDateString() + ' ' + startDate.toLocaleTimeString();
                html += `<tr class='compare-activity-row' data-id='${activity.id}' title='${startDateFormatted}'>
                    <td>${dateStr}</td>
                    <td class='name'>${escapeHtml(activity.name)}</td>
                    <td>${distance}</td>
                    <td>${time}</td>
                </tr>`;
            }
        });
        html += '</tbody>';
        $table.html(html);
        $section.show();

        $('#my-activities').stupidtable(stupidTableSortFunctions);

        // Bind click handlers for comparison activity selection
        $('.compare-activity-row').on('click', function () {
            const activityId = $(this).data('id');
            $section.hide();
            uploadCompareGpxFromStrava(activityId);
        });
    }

    // Upload comparison activity from Strava
    async function uploadCompareGpxFromStrava(activityId) {
        showLoader();
        try {
            const response = await fetch(API.upload, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ stravaActivityId: activityId.toString(), timezoneOffsetActivityLocation: state.timezoneOffsetActivityLocation })
            });
            const result = await response.json();
            debug('uploadCompareGpxFromStrava compare state=');
            debug(result);
            if (result.success) {
                // Store original activity state before comparison
                state.originalState = {
                    gpxXml: state.gpxXml,
                    coordinates: state.coordinates,
                    summary: state.summary,
                    hasHeartRate: state.hasHeartRate,
                    hasTime: state.hasTime,
                    fileName: state.fileName
                };

                // Parse compare coordinates
                let compareCoordinates = parseApiArray(result.coordinates) || [];

                // Store comparison activity state
                state.compareState = {
                    gpxXml: result.gpxXml,
                    coordinates: compareCoordinates,
                    summary: result.summary,
                    hasHeartRate: result.hasHeartRate,
                    hasTime: result.hasTime,
                    fileName: result.fileName || ('<a target="strava" href="https://www.strava.com/activities/' + result.stravaActivityId + '">Strava Activity ' + result.stravaActivityId + '</a>')
                };

                // Enter comparison mode
                enterCompareMode();
            } else {
                showError(result.message || 'Failed to load comparison activity from Strava.', result.additionalInfo);
            }
        } catch (error) {
            console.error('Compare upload from Strava error:', error);
            showError('An error occurred while loading the comparison activity.');
        } finally {
            hideLoaders();
        }
    }

    function showDownloadPanel() {
        if (!state.gpxXml) return;

        const $link = $('#download-link');
        const blob = new Blob([state.gpxXml], { type: 'application/gpx+xml; charset=utf-8' });
        const url = URL.createObjectURL(blob);

        let fileName = state.fileName || 'activity';
        if (!fileName.endsWith('.gpx')) fileName += '.gpx';
        fileName = fileName.replace('.gpx', '_updated.gpx');

        $link.attr('href', url);
        $link.attr('download', fileName);
        $link.show();
        $('#download-area').show();

        // Show submit for review button only if operations have been performed (not on first upload)
        // AND review has not already been submitted for this activity
        // state.isFirstLoad is true on initial upload, false after any operation
        if (state.originalState && state.originalState.gpxXml && !state.isFirstLoad && !state.reviewSubmitted) {
            $('#btn-submit-review').show();
        }

        populateSportTypeDropdown();
    }

    function initializeMap() {
        //if (!state.coordinates || state.coordinates.length === 0) return;

        const isFirstLoad = !state.map;

        if (state.map) {
            state.map.remove();
            state.map = null;
        }

        // Indoor / trainer workouts have track point data (time, HR, speed, distance) but no GPS
        // position. Don't show an empty map for them — hide the map element but still set up the
        // slider and chart so their data is available.
        const hasGps = !state.summary || state.summary.hasGpsCoordinates !== false;
        if (!hasGps) {
            $('#map').hide();
            // No map means the fullscreen toggle has nothing to show, so hide it too.
            $('#btn-fullscreen').hide();
            // These actions all operate on the GPS track, which is absent for indoor / trainer
            // workouts, so disable them together with the map.
            $('#btWaypoints, #btSmoothenGps, #btFixGps, #btEdit').addClass('disabled').attr('aria-disabled', 'true');
            setupSlider();
            printCoordinateInfo(0);
            return;
        }

        $('#map').show();
        $('#btn-fullscreen').show();
        $('#btWaypoints, #btSmoothenGps, #btFixGps').removeClass('disabled').removeAttr('aria-disabled');
        state.map = L.map('map', { editable: true }).setView([0, 0], 13);

        const osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 22,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(state.map);

        const Esri_WorldImagery = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            attribution: '&copy; Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, GIS User Community'
        });

        const baseMaps = {
            "Map View": osm,
            "Satellite View": Esri_WorldImagery
        };
        L.control.layers(baseMaps).addTo(state.map);

        //updateMap(isFirstLoad);
        updateMap(true);
    }

    function updateMap(fitBounds = false) {
        debug('updatemap fitBounds=' + fitBounds);
        debug('state=');
        debug(state);
        let fitBoundsSet = false;
        if (!state.map) return;

        if ((!state.coordinates || state.coordinates.length === 0)
            && (!state.waypoints || state.waypoints.length === 0)) return;
        // Remove existing polyline and marker
        if (state.polyline) {
            state.map.removeLayer(state.polyline);
        }
        if (state.marker) {
            state.map.removeLayer(state.marker);
        }
        // Remove existing waypoint markers
        if (state.waypointMarkers) {
            state.waypointMarkers.forEach(marker => state.map.removeLayer(marker));
        }

        if (state.coordinates && state.coordinates.length > 0) {
            // Coordinates format: [[{lat, lon}, hr, time, ele, speed, cad], ...]
            // Single-pass build avoids the cost of map(...).filter(...) over potentially
            // very large GPX track point arrays.
            const coords = state.coordinates;
            const latlngs = [];
            for (let i = 0; i < coords.length; i++) {
                const c = coords[i];
                if (c && c[0]) {
                    const lat = c[0].lat;
                    const lon = c[0].lon;
                    if (lat !== 0 || lon !== 0) {
                        latlngs.push([lat, lon]);
                    }
                }
            }

            if (latlngs.length !== 0) {
                state.polyline = L.polyline(latlngs, { color: '#dc2b00', weight: 3 }).addTo(state.map);

                // Only fit bounds on first load
                if (fitBounds) {
                    state.map.fitBounds(state.polyline.getBounds());
                    fitBoundsSet = true;
                }
                // Add start marker
                state.marker = L.marker(latlngs[0]).addTo(state.map);
            }

            setupSlider();
            printCoordinateInfo(0);

            // The polyline only exists when the activity has real GPS coordinates. Coordinate-less
            // activities (e.g. indoor / trainer workouts) still have a slider and chart, so guard
            // the polyline-dependent setup to avoid aborting the rest of the handler.
            if (state.polyline) {
                const origCoordsRaw = state.polyline.getLatLngs();
                state.origLatLngs = origCoordsRaw.map(latlng => L.latLng(latlng.lat, latlng.lng));

                window.GpxFixMap.setEditCoordinateLimits();

                // Click on the map moves the slider to the nearest track point
                // (skip when in point-edit or waypoint-edit mode so those clicks aren't stolen)
                state.map.off('click', onMapClickTrack);
                state.map.on('click', onMapClickTrack);
            }
        }

        // Add waypoints
        state.waypointMarkers = [];
        if (state.waypoints && state.waypoints.length > 0) {
            debug('adding ' + state.waypoints.length + ' waypoints');
            state.waypointMarkers = window.GpxFixMap.renderWaypointMarkers(state.map, state.waypoints);
            if (fitBounds && !fitBoundsSet) {
                const waypointBounds = L.latLngBounds(state.waypoints.map(wpt => [wpt.lat, wpt.lon]));
                state.map.fitBounds(waypointBounds);
                fitBoundsSet = true;
            }
        }

        // Render spike-zone warning markers.
        // These mark areas where the GPS signal was erratic (e.g. the user went indoors).
        // Existing markers are cleared and recreated each time the map is refreshed.
        state.spikeZoneMarkers = window.GpxFixMap.renderSpikeZoneMarkers
            ? window.GpxFixMap.renderSpikeZoneMarkers(state.map, state.spikeZones, state.spikeZoneMarkers)
            : [];
    }


    function setupSlider() {
        //debug('setupslider spa.js');
        if (!state.coordinates || state.coordinates.length === 0) return;

        const $slider = $('#timeSlider');
        $slider.attr('max', state.coordinates.length - 1);
        $slider.val(0);

        $slider.off('input').on('input', function () {
            //debug('input on change....');
            const idx = parseInt($(this).val());
            if (state.coordinates[idx]) {
                //debug('state.coordinates['+idx);
                printCoordinateInfo(idx);
                moveVerticalLineTo(idx);
                // Keep the 'insert/remove time at point' sub-panel in sync while the user drags
                if ($('#panel-changedate-atpoint').is(':visible')) {
                    refreshChangeDateAtPointInfo();
                }
            }
        });
    }

    function printCoordinateInfo(idx) {
        if (!state.coordinates) return;
        const coord = state.coordinates[idx];
        if (state.marker && coord[0]) {
            state.marker.setLatLng([coord[0].lat, coord[0].lon]);
        }

        var startTime = new Date(state.summary.startTimeUtc);

        const localStartTimeAtActivity = addHours(startTime, state.summary.timezoneOffsetActivityLocation);
        const startTimeAtActivityBrowserAdjusted = addHours(localStartTimeAtActivity, browserTimezoneOffset);

        const localTimeAtActivity = addHours(new Date(coord[2]), state.summary.timezoneOffsetActivityLocation);
        const timeAtActivityBrowserAdjusted = addHours(localTimeAtActivity, browserTimezoneOffset);

        let info = formatPointPreviewInfo(idx, state.coordinates.length, startTimeAtActivityBrowserAdjusted, timeAtActivityBrowserAdjusted,
            coord[1], coord[3], coord[4], coord[5], coord[6], coord[7]);
        ;



        $('#mapOutput').html(info);
    }

    function moveVerticalLineTo(newX) {
        // Delegate to shared chart module
        if (state.chart) {
            chartModule.moveVerticalLineTo(state.chart, newX);
        }
    }

    // Populates the 'at current point' sub-panel with info about the currently selected
    // track point: its index, the gap from the previous point, and the maximum seconds
    // that can safely be removed (gap - 1). Defined at module scope so both
    // setupEventHandlers and handleAction can call it.
    function refreshChangeDateAtPointInfo() {
        const idx = parseInt($('#timeSlider').val()) || 0;
        const coordCount = state.coordinates ? state.coordinates.length : 0;

        if (idx <= 0 || !state.coordinates || !state.coordinates[idx] || !state.coordinates[idx - 1]) {
            // First point or no valid coordinates – removal not allowed here
            $('#changedate-atpoint-info').text(`Track point: ${idx + 1} of ${coordCount}. Use time slider to select a point`);
            $('#changedate-atpoint-gap-info').text('Cannot insert or remove time at the first track point.');
            $('#input-atpoint-seconds').attr('min', 1).attr('max', 3600).val(1);
            return;
        }

        const currTime = new Date(state.coordinates[idx][2]);
        const prevTime = new Date(state.coordinates[idx - 1][2]);
        const gapSeconds = Math.round((currTime - prevTime) / 1000);
        const maxRemovable = Math.max(0, gapSeconds - 1);

        $('#changedate-atpoint-info').text(`Track point: ${idx + 1} of ${coordCount}`);
        if (maxRemovable > 0) {
            $('#changedate-atpoint-gap-info').text(`Gap from previous point: ${gapSeconds}s — max removable: ${maxRemovable}s`);
            $('#input-atpoint-seconds').attr('min', -maxRemovable).attr('max', 3600);
        } else {
            $('#changedate-atpoint-gap-info').text(`Gap from previous point: ${gapSeconds}s — points are consecutive, removal not available`);
            $('#input-atpoint-seconds').attr('min', 1).attr('max', 3600).val(1);
        }
    }

    // Event Handlers
    function setupEventHandlers() {
        debug('setupEventHandlers');
        // ── Shared file-validation and upload helper ──────────────────────────────
        // Called for the main activity upload so that validation logic lives in
        // exactly one place, regardless of whether the user dragged, dropped, or
        // picked the file via the native dialog.
        function processFile(file) {
            if (!file) return;

            const allowedExtensions = ['.gpx', '.xml', '.fit', '.tcx'];
            const fileName = file.name.toLowerCase();
            const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
            if (!hasValidExtension) {
                showError('Invalid file type. Please upload a GPX, XML, FIT, or TCX file.');
                return;
            }

            if (file.size > 15 * 1024 * 1024) {
                showError('File is too large.', 'Maximum size is 15 MB.');
                return;
            } else if (file.size < (fileName.endsWith('.tcx') ? 1000 : 5000)) {
                showError('Not a valid activity file.', 'File size is too small to represent a valid workout. GpxFix is developed for outdoor activities with GPS coordinates.');
                return;
            }

            showLoader('loader-activity');
            const reader = new FileReader();
            reader.onload = function (e) {
                state.fileName = file.name;
                uploadGpx(e.target.result);
            };
            if (fileName.endsWith('.fit')) {
                reader.readAsArrayBuffer(file);
            } else {
                reader.readAsText(file);
            }
        }

        // ── Helper for the comparison file pick ───────────────────────────────────
        function processCompareFile(file) {
            if (!file) return;
            if (file.size > 15 * 1024 * 1024) {
                showError('File is too large. Maximum size is 15 MB.');
                return;
            } else if (file.size < 1000) {
                showError('Not a valid GPX file.');
                return;
            }
            showLoader('loader-activity');
            const reader = new FileReader();
            reader.onload = function (evt) {
                uploadCompareGpx(evt.target.result, file.name);
            };
            reader.readAsText(file);
        }

        // ── Helper for the combine file pick ──────────────────────────────────────
        function processCombineFile(file) {
            if (!file) return;
            if (file.size > 15 * 1024 * 1024) {
                showError('File is too large. Maximum size is 15 MB.');
                return;
            } else if (file.size < 1000) {
                showError('Not a valid GPX file.');
                return;
            }
            const reader = new FileReader();
            reader.onload = function (e) {
                executeOperation('combine', { secondGpxXml: e.target.result });
            };
            reader.readAsText(file);
        }

        // ── Helper for the restore-from-reference file pick ───────────────────────
        function processRestoreRefFile(file) {
            if (!file) return;
            const reader = new FileReader();
            reader.onload = function (e) {
                // Read the currently selected tile's data-restore value to decide mode
                const selectedTileVal = $('.restore-method-tile.selected').data('restore');
                const restoreReferenceMode = selectedTileVal === 'extend' ? 'extend' : 'repair';
                executeOperation('restoremissingfromreference', { secondGpxXml: e.target.result, restoreReferenceMode });
            };
            reader.readAsText(file);
        }

        // ── Wire up all reusable drop zones using initGpxDropZone (Common.js) ─────
        // Main activity upload zone
        initGpxDropZone('drop-zone', 'file-input', processFile);

        // Comparison activity upload zone (rendered inside panel-compare)
        initGpxDropZone('drop-zone-compare', 'file-compare', processCompareFile);

        // Combine activity upload zone (rendered inside panel-combine)
        initGpxDropZone('drop-zone-combine', 'file-combine', processCombineFile);

        // Restore GPS from reference file upload zone (rendered inside panel-restoremissinggps)
        initGpxDropZone('drop-zone-restore-ref', 'file-restore-ref', processRestoreRefFile);

        // Smoothen GPS toward reference file upload zone (rendered inside panel-smoothengps)
        initGpxDropZone('drop-zone-smoothen-ref', 'file-smoothen-ref', function (file) {
            if (!file) return;
            if (file.size > 15 * 1024 * 1024) {
                showError('File is too large. Maximum size is 15 MB.');
                return;
            } else if (file.size < 1000) {
                showError('Not a valid GPX file.');
                return;
            }
            const reader = new FileReader();
            reader.onload = function (e) {
                executeOperation('smoothengps', { smoothenGpsMode: 'reference', secondGpxXml: e.target.result });
            };
            reader.readAsText(file);
        });

        // Exit comparison mode
        $('#btn-exit-compare').on('click', function (e) {
            e.preventDefault();
            exitCompareMode();
        });

        $('input[name="compareViewMode"]').on('change', function () {
            if (!state.compareMode) return;
            state.compareViewMode = this.value === 'overlay' ? 'overlay' : 'side-by-side';
            renderCompareView();
            window.GpxFixMap.addSliderSyncEventHandlersIfNotAdded();
        });

        const btnSaveStrava = document.getElementById('btn-save-strava');
        if (btnSaveStrava) {
            btnSaveStrava.addEventListener('click', saveToStrava);
        }

        // Submit for Review button and modal handlers
        const btnSubmitReview = document.getElementById('btn-submit-review');
        if (btnSubmitReview) {
            btnSubmitReview.addEventListener('click', function() {
                $('#review-modal').show();
            });
        }

        $('#closeReviewModal, #btn-cancel-review').on('click', function() {
            $('#review-modal').hide();
            $('#review-description').val('');
        });

        $('#btn-confirm-review').on('click', async function() {
            await submitActivityForReview();
        });

        // Delegated change handler for the sport type dropdown.
        // The dropdown is rebuilt every time updateActivityInfo() runs, so we listen on
        // the document rather than binding directly to the (recreated) element.
        $(document).on('change', '#select-sport-type', function () {
            const newType = $(this).val();
            if (!newType) return; // '-- Keep original --' selected; nothing to change

            // 1. Update the displayed activity type label beside the dropdown
            $('#activity-type-display').text(newType);

            // 2. Update application state so subsequent saves and operations use the new type
            if (state.activityMetadata) {
                state.activityMetadata.sportType = newType;
            } else {
                state.activityMetadata = { sportType: newType };
            }

            // 3. Update the <type> element inside <trk> in the stored GPX XML so the
            //    downloaded file and any further server operations reflect the new type
            if (state.gpxXml) {
                state.gpxXml = updateGpxSportType(state.gpxXml, newType);
            }

            // 4. Regenerate the download blob URL so the "Download GPX file" link
            //    immediately serves the updated XML even when no other operation was run
            showDownloadPanel();
        });

        // Sync sliders in compare mode
        $('#chk-sync-sliders').on('change', function () {
            state.syncCompareSliders = this.checked;
        });
        state.syncCompareSliders = true;

        // Compare slider 1
        $('#compare-slider-1').on('input', function () {
            const idx = parseInt(this.value);
            updateCompareMarker(1, idx);

            if (state.compareChart2) {
                chartModule.moveVerticalLineTo(state.compareChart1, idx);
            }
        });

        // Compare slider 2
        $('#compare-slider-2').on('input', function () {
            const idx = parseInt(this.value);
            updateCompareMarker(2, idx);
            if (state.compareChart2) {
                chartModule.moveVerticalLineTo(state.compareChart2, idx);
            }
        });

        // Strava activities button (main upload)
        $('#btn-pick-strava').on('click', function (e) {
            e.stopPropagation();
            //debug('pick-strava click');
            loadStravaActivities();
        });

        // Strava activities button (for comparison)
        $('#btn-pick-strava-comparison').on('click', function (e) {
            //debug('pick-strava-comparison click');
            e.preventDefault();
            loadStravaActivitiesForComparison();
        });

        $('#menu .btAction a').on('click', function (e) {
            //debug('Action menu clicks');
            e.preventDefault();
            // Ignore clicks on actions that are disabled (e.g. GPS actions for a no-coordinate workout).
            if ($(this).hasClass('disabled')) return;
            const action = $(this).data('action');
            handleAction(action);
        });

        // Action category filter
        $('input[name="radioMenuSection"]').on('change', function () {
            const value = $(this).val();
            if (value === 'all') {
                $('#menu li').show();
            } else {
                $('#menu li').hide();
                $('#menu li.cat-' + value).show();
            }
        });

        $('#btn-changeelapsedtime').on('click', function () {
            const seconds = parseInt($('#input-seconds-change').val());
            if (isNaN(seconds) || seconds === 0 || seconds < -3600 || seconds > 3600) {
                showError('Please enter a number between -3600 and 3600 (not zero).');
                return;
            }
            if (seconds > 0) {
                executeOperation('increasetime', { secondsToAdd: seconds });
            } else {
                executeOperation('reducetime', { secondsToAdd: seconds });
            }
        });

        // Toggle between the two sub-panels when the user switches radio modes.
        $('input[name="changeDateMode"]').on('change', function () {
            const val = $(this).val();
            if (val === 'starttime') {
                $('#panel-changedate-start').show();
                $('#panel-changedate-atpoint').hide();
            } else {
                $('#panel-changedate-start').hide();
                $('#panel-changedate-atpoint').show();
                refreshChangeDateAtPointInfo();
            }
        });

        $('#btn-changedate').on('click', function () {
            const mode = $('input[name="changeDateMode"]:checked').val();

            if (mode === 'atpoint') {
                // Insert / remove time at the currently selected track point
                const idx = parseInt($('#timeSlider').val()) || 0;
                if (idx <= 0) {
                    showError('Cannot insert or remove time at the first track point. Use the slider to select a different point.');
                    return;
                }

                const seconds = parseInt($('#input-atpoint-seconds').val());
                if (!seconds || seconds === 0) {
                    showError('Please enter a non-zero number of seconds.');
                    return;
                }

                // Client-side guard: prevent removing more time than the gap allows.
                if (seconds < 0 && state.coordinates && state.coordinates[idx] && state.coordinates[idx - 1]) {
                    const gapSeconds = Math.round((new Date(state.coordinates[idx][2]) - new Date(state.coordinates[idx - 1][2])) / 1000);
                    if (-seconds >= gapSeconds) {
                        showError(`Cannot remove ${-seconds}s — the gap from the previous point is only ${gapSeconds}s. Maximum removable: ${gapSeconds - 1}s.`);
                        return;
                    }
                }

                executeOperation('inserttimeatpoint', { trackPointIndex: idx, secondsToAdd: seconds });
            } else {
                // Change start time (original behaviour)
                const newDate = $('#input-newdate').val();
                if (!newDate) {
                    showError('Please select a date and time.');
                    return;
                }
                executeOperation('changedate', { newDateTime: new Date(newDate).toISOString() });
            }
        });

        $('#btn-calibrateelevation').on('click', function () {
            const eleMin = $('#input-ele-min').val();
            const eleMax = $('#input-ele-max').val();
            const eleAdd = $('#input-ele-add').val();
            // Read the smoothen checkbox � true means a moving-average pass will be applied server-side
            const eleSmoothen = $('#chk-ele-smoothen').is(':checked');

            if (!eleMin && !eleMax && !eleAdd && !eleSmoothen) {
                showError('Please enter at least one elevation value or check Smoothen elevation profile.');
                return;
            }

            executeOperation('calibrateelevation', {
                elevationCalibrationMin: eleMin ? parseFloat(eleMin) : null,
                elevationCalibrationMax: eleMax ? parseFloat(eleMax) : null,
                elevationCalibrationAdd: eleAdd ? parseFloat(eleAdd) : null,
                elevationCalibrationSmoothen: eleSmoothen || null
            });
        });

        // Validates that there are enough track points for meaningful GPS/HR fixing operations
        // Returns true if validation passes, false otherwise (and shows error message)
        function validateMinimumTrackPoints() {
            const trackPointCount = state.coordinates ? state.coordinates.length : 0;
            if (trackPointCount < 30) {
                showError('There are too few track points (' + trackPointCount + ') for a meaningful GPS fixing to be carried out. At least 30 track points are required.');
                return false;
            }
            return true;
        }

        $('#btn-fixgps-apply').on('click', function () {
            // Check if there are enough track points for meaningful GPS fixing
            if (!validateMinimumTrackPoints()) {
                return;
            }

            const fixType = $('input[name="radioGpsFix"]:checked').val() || 'all';
            const params = { fixType: fixType };
            // Pass spikeZonesPreDetected if spike zones were detected during upload
            if (state.spikeZones && state.spikeZones.length > 0) {
                params.spikeZonesPreDetected = true;
            }
            executeOperation('fixgps', params);
        });

        // Correct track segment button - snaps selected segment to road using current timeSlider position
        $('#btn-correct-segment').on('click', function () {
            if (!state.gpxXml) {
                showUploadFileMessage();
                return;
            }

            // Check if there are enough track points for meaningful GPS fixing
            if (!validateMinimumTrackPoints()) {
                return;
            }

            // Get the current position from the timeSlider (0-based index)
            const sliderValue = parseInt($('#timeSlider').val()) || 0;
            const trackPointCount = state.coordinates ? state.coordinates.length : 0;

            // Check if user has selected a track point (slider not at default position 0)
            if (sliderValue === 0) {
                showError('Please click on the map where the bad segment is off course, or use the slider below the map to select a track point in the problematic area.');
                return;
            }

            // Convert from 0-based slider index to 1-based track point index
            const segmentStartIndex = sliderValue + 1;

            if (segmentStartIndex < 1 || segmentStartIndex > trackPointCount) {
                showError('Please use the slider below the map to select a track point first.');
                return;
            }

            executeOperation('correctsegment', { segmentStartIndex: segmentStartIndex });
        });

        // "Just fix it" button - applies multiple fixes in a single backend operation
        $('#btn-just-fix-it').on('click', function () {
            if (!state.gpxXml) {
                showUploadFileMessage();
                return;
            }

            // Check if there are enough track points for meaningful GPS fixing
            if (!validateMinimumTrackPoints()) {
                return;
            }

            // Pass spikeZonesPreDetected if spike zones were detected during upload
            const params = {};
            if (state.spikeZones && state.spikeZones.length > 0) {
                params.spikeZonesPreDetected = true;
            }

            // Single backend call that handles GPS fixes, HR fixes, and still time removal
            executeOperation('justfixit', params);
        });

        function updateCropDeleteTimeVisibility() {
            const startIdx = $('#input-crop-start').val();
            const endIdx = $('#input-crop-end').val();
            if (startIdx && endIdx) {
                $('#crop-delete-time-option').show();
            } else {
                $('#crop-delete-time-option').hide();
                $('#chk-crop-delete-time').prop('checked', false);
            }
        }
        $('#input-crop-start, #input-crop-end').on('input', updateCropDeleteTimeVisibility);

        $('#btn-crop').on('click', function () {
            const startIdx = $('#input-crop-start').val();
            const endIdx = $('#input-crop-end').val();
            const pointsCount = state.coordinates.length;
            if (!startIdx && !endIdx) {
                showError('Please enter at least start or end point.');
                return;
            }

            if (pointsCount < 6) {
                showError('This track is too short to be cropped');
                return;
            }
            if (!/^(?:[-+]?\d*\.?\d+)?$/.test(startIdx)) {
                showError('Please enter a valid number for start point or leave blank.');
                return;
            }
            if (!/^(?:[-+]?\d*\.?\d+)?$/.test(endIdx)) {
                showError('Please enter a valid number for end point or leave blank.');
                return;
            }
            if (!endIdx && !startIdx) {
                showError('Please enter a number for either the start or end track point.');
                return;
            }
            if ((startIdx < 1 || startIdx > pointsCount) && startIdx) {
                showError('Please enter a non-zero positive number for start point lower than ' + pointsCount);
                return;
            }
            if ((endIdx < 1 || endIdx > pointsCount) && endIdx) {
                showError('Please enter a non-zero positive number for end point lower than ' + pointsCount);
                return;
            }
            if (startIdx > 0 && endIdx > 0 && (parseInt(startIdx) > parseInt(endIdx))) {
                showError('Start point can not be higher than end point.');
                return;
            }
            if (startIdx && endIdx && ((endIdx - startIdx) >= pointsCount - 2)) {
                showError('Cannot remove all track points. Please choose a smaller segment to remove');
                return;
            }
            if (startIdx && !endIdx && startIdx < 5) {
                showError('Does not make sense to crop this much');
                return;
            }


            executeOperation('crop', {
                cropStartIndex: startIdx ? parseInt(startIdx) : null,
                cropEndIndex: endIdx ? parseInt(endIdx) : null,
                cropDeleteTime: $('#chk-crop-delete-time').is(':checked') ? true : null
            });
        });

        $('#btn-crop-select-chart').on('click', function () {
            if (!state.chart) {
                showError('No chart available. Please upload an activity first.');
                return;
            }
            const $btn = $(this);
            const isActive = $btn.hasClass('active');
            if (isActive) {
                chartModule.disableCropRangeSelection(state.chart);
                chartModule.clearCropRange(state.chart);
                $btn.text('Select on chart').removeClass('active');
                $('#crop-chart-selection-label').text('');
            } else {
                $btn.text('Cancel selection').addClass('active');
                $('#crop-chart-selection-label').text('Drag on the chart to select the section to remove');
                chartModule.enableCropRangeSelection(state.chart, function (range) {
                    // Convert 0-based chart index to 1-based track point number
                    const start = range.startIndex + 1;
                    const end = range.endIndex + 1;
                    $('#input-crop-start').val(start);
                    $('#input-crop-end').val(end);
                    $('#crop-chart-selection-label').text('Selected: points ' + start + ' to ' + end);
                    $btn.text('Select on chart').removeClass('active');
                });
            }
        });

        /**
         * Shows or hides the "Remove non-moving end" section inside the crop panel.
         * The section is only shown after fetchNonMovingEndIndex() has stored a
         * positive index in state.summary.nonMovingEndStartIndex.
         */
        function updateNonMovingEndButtonVisibility() {
            const idx = state.summary && state.summary.nonMovingEndStartIndex;
            if (idx && idx > 0) {
                $('#crop-nonmoving-end-section').show();
            } else {
                $('#crop-nonmoving-end-section').hide();
            }
        }

        /**
         * Calls the lightweight 'getnonmovingendindex' API operation to detect whether
         * the current activity has a stationary tail section.
         * On success the index is stored in state.summary.nonMovingEndStartIndex and
         * the crop-panel button visibility is updated.
         * This is intentionally called only when the user opens the crop panel so that
         * the scan does not run on every upload or operation response.
         */
        async function fetchNonMovingEndIndex() {
            // Hide the section optimistically while the request is in flight.
            $('#crop-nonmoving-end-section').hide();
            try {
                const requestBody = {
                    gpxXml: state.gpxXml,
                    operation: 'getnonmovingendindex'
                };
                const response = await fetch(API.operation, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(requestBody)
                });
                const result = await response.json();
                if (result.success) {
                    // Store the index so updateNonMovingEndButtonVisibility can read it.
                    if (state.summary) {
                        state.summary.nonMovingEndStartIndex = result.nonMovingEndStartIndex;
                    }
                    updateNonMovingEndButtonVisibility();
                }
            } catch (err) {
                // Detection is best-effort; silently ignore network or parse errors.
                console.warn('fetchNonMovingEndIndex failed:', err);
            }
        }

        // One-click removal of the stationary end section.
        $('#btn-remove-nonmoving-end').on('click', function () {
            executeOperation('removenonmovingend', {});
        });

        // When the crop panel is opened, lazily call getnonmovingendindex so the
        // 'Remove non-moving end' button is shown or hidden without running the
        // expensive scan on every upload or operation response.
        // This listener is registered here (inside setupEventHandlers) so that
        // fetchNonMovingEndIndex is within scope.
        $(document).on('panelShown.crop', function (e, panelId) {
            if (panelId === 'crop' && state.gpxXml) {
                fetchNonMovingEndIndex();
            }
        });

        $('#btChangeElapsedTime').on('click', function (e) {
            hideAllPanels();
            e.preventDefault();
            if (state.gpxXml === null) {
                showUploadFileMessage();
                return;
            }
            if (!hasValidTimeData(e)) {
                return;
            }
            $('#panel-changeelapsedtime').show();
            $('#input-seconds-change').focus();
        });

        function hasValidTimeData(e) {
            debug('hasValidTimeData check: ' + state.hasTime);
            if (state.hasTime === false) {
                //if($('#hasTime').val()==='0'){ 
                debug('hasValidTimeData');

                showError('This workout does not have timestamp data.');
                e.preventDefault();
                return false;
            }
            return true;
        }

        $('#btn-updatedistance').on('click', function () {
            const meters = parseInt($('#input-meters-add').val());
            if (isNaN(meters) || meters < -100 || meters > 100 || meters === 0) {
                showError('Please enter a non-zero number between -100 and 100.');
                return;
            }
            executeOperation('updatedistance', { metersToAdd: meters });
        });

        // GPS restore with reference file
        $('#btn-restoremissinggps').on('click', function () {
            // When checked, also rebuild a missing start/finish by mirroring the out-and-back segment.
            const allowExtendStartFinish = $('#chk-restore-extend-startfinish').is(':checked');
            executeOperation('restoremissingfromself', { allowExtendStartFinish });
        });

        $('#btn-restoreindoor').on('click', function () {
              executeOperation('restoreindoor', {});
          });

          // Restore time gap: fills gaps of 30s�10min using interpolation.
          // Reads the optional approximate track point index so the server can target a specific gap.
          $('#btn-restore-timegap').on('click', function () {
              const approxRaw = $('#input-timegap-approx-index').val();
              // Parse to integer when the user typed something; send null to fix all gaps when blank
              const approxTrackPointIndex = approxRaw !== '' ? parseInt(approxRaw, 10) : null;
              const rerouteToKnownPath = $('#chk-timegap-reroute-known-path').is(':checked');
              executeOperation('restoretimegap', { approxTrackPointIndex, rerouteToKnownPath });
          });

        // Restore method tile selector: clicking a tile activates it and shows the matching sub-panel
          $('.restore-method-tile').on('click', function () {
              const val = $(this).data('restore');

              // Update selected-tile visual state
              $('.restore-method-tile').removeClass('selected');
              $(this).addClass('selected');

              // Show only the sub-panel that matches the selected tile
              $('#divRestoreGpsFromSelf').toggle(val === 'route');
              $('#divRestoreGpsFromOther').toggle(val === 'file' || val === 'extend');
              $('#divRestoreGpsFromOtherBasic').toggle(val === 'file');
              $('#divRestoreGpsFromOtherExtend').toggle(val === 'extend');
              $('#divRestoreGpsFromIndoor').toggle(val === 'indoor');
              $('#divRestoreGpsFromTimeGap').toggle(val === 'timegap');
          });

          // Fix HR - analyze and fix heart rate issues
        $('#btn-fixhr').on('click', function () {
            // Check if there are enough track points for meaningful HR fixing
            if (!validateMinimumTrackPoints()) {
                return;
            }

            const hrIssueType = $('input[name="radioHrIssue"]:checked').val();
            const minHr = textToNumberOrNull($('#input-hr-min').val());
            const maxHr = textToNumberOrNull($('#input-hr-max').val());
            debug('hrIssueType =' + hrIssueType);

            if (hrIssueType === 'selectbadsegments') {
                const segments = chartModule.getBadSegments();
                if (!segments || segments.length === 0) {
                    showError('Please drag on the chart to select at least one bad HR segment.');
                    return;
                }
                chartModule.disableBadSegmentSelection(state.chart);
                chartModule.clearBadSegments(state.chart);
                updateBadSegmentList();
                executeOperation('fixhr', { hrIssueType: hrIssueType, hrBadSegments: segments });
            } else {
                executeOperation('fixhr', { hrIssueType: hrIssueType, minHr: minHr, maxHr: maxHr });
            }
        });

        // Show or hide the reference-file upload area depending on the selected smoothing mode
        $('input[name="radioSmoothenGps"]').on('change', function () {
            var val = $(this).val();
            if (val === 'reference') {
                $('#div-smoothen-ref-upload').show();
            } else {
                $('#div-smoothen-ref-upload').hide();
                $('#file-smoothen-ref').val('');
            }
        });

        // Smoothen GPS - apply the selected smoothing mode to the track
        $('#btn-smoothengps').on('click', function () {
            // Read which smoothing mode the user selected (basic / snaptoroad / strong / reference)
            const smoothenGpsMode = $('input[name="radioSmoothenGps"]:checked').val() || 'basic';

            // Reference mode auto-triggers on file selection, so ignore button click for that mode
            if (smoothenGpsMode === 'reference') {
                showError('Please upload a reference GPX file to start smoothening.');
                return;
            }

            executeOperation('smoothengps', { smoothenGpsMode: smoothenGpsMode });
        });

        $('input[name="radioHrIssue"]').on('change', function () {
            var val = $(this).val();
            if (val === 'normalize') {
                $('#div-normalize-minmax').show();
            } else {
                $('#div-normalize-minmax').hide();
            }

            if (val === 'selectbadsegments') {
                $('#div-select-bad-segments').show();
                chartModule.clearBadSegments(state.chart);
                updateBadSegmentList();
                chartModule.enableBadSegmentSelection(state.chart, function () {
                    updateBadSegmentList();
                });
            } else {
                $('#div-select-bad-segments').hide();
                chartModule.disableBadSegmentSelection(state.chart);
                chartModule.clearBadSegments(state.chart);
            }
        });

        function updateBadSegmentList() {
            var segments = chartModule.getBadSegments();
            var $list = $('#bad-segments-list');
            $list.empty();
            if (segments.length === 0) {
                $list.html('<p><em>No segments selected yet. Drag on the chart to select bad HR regions.</em></p>');
                $('#btn-clear-bad-segments').hide();
                return;
            }
            for (var i = 0; i < segments.length; i++) {
                var seg = segments[i];
                var $item = $('<div class="bad-segment-item"></div>');
                $item.html('Segment ' + (i + 1) + ': points ' + (seg.startIndex + 1) + ' - ' + (seg.endIndex + 1) +
                    ' <button type="button" class="btn-remove-bad-seg" data-idx="' + i + '" title="Remove">&times;</button>');
                $list.append($item);
            }
            $('#btn-clear-bad-segments').show();

            // Bind remove buttons
            $list.find('.btn-remove-bad-seg').off('click').on('click', function () {
                var idx = parseInt($(this).data('idx'));
                chartModule.removeBadSegment(state.chart, idx);
                updateBadSegmentList();
            });
        }

        $('#btn-clear-bad-segments').on('click', function () {
            chartModule.clearBadSegments(state.chart);
            updateBadSegmentList();
        });

        // Resample track
        $('#btn-resample').on('click', function () {
            const targetPoints = parseInt($('#input-target-trackpoints').val());
            const currentPoints = state.summary?.coordinatesCount || 0;

            if (isNaN(targetPoints) || targetPoints < 10 || targetPoints > 50000) {
                showError('Please enter a number between 10 and 50000.');
                return;
            }

            if (targetPoints === currentPoints) {
                showError('Target points is the same as current points. Please enter a different value.');
                return;
            }

            executeOperation('resample', { targetTrackPoints: targetPoints });
        });

        $('#chk-strip-all').on('change', function () {
            const checked = $(this).prop('checked');
            $('.chk-strip-opt').prop('checked', checked);
        });

        $('.chk-strip-opt').on('change', function () {
            const allChecked = $('.chk-strip-opt').length === $('.chk-strip-opt:checked').length;
            $('#chk-strip-all').prop('checked', allChecked);
        });

        $('#btn-strip').on('click', function () {
            const heartRate = $('#chk-strip-hr').prop('checked');
            const cadence = $('#chk-strip-cadence').prop('checked');
            const power = $('#chk-strip-power').prop('checked');
            const timeAndSpeed = $('#chk-strip-time').prop('checked');
            const elevation = $('#chk-strip-elevation').prop('checked');
            const temperature = $('#chk-strip-temperature').prop('checked');
            const metadata = $('#chk-strip-metadata').prop('checked');
            const minify = $('#chk-strip-minify').prop('checked');

            if (!heartRate && !cadence && !power && !timeAndSpeed && !elevation && !temperature && !metadata && !minify) {
                showError('Please select at least one option to strip or minify.');
                return;
            }

            executeOperation('strip', {
                stripOptions: { heartRate, cadence, power, timeAndSpeed, elevation, temperature, metadata, minify }
            });
        });

        $('#map').on('contextmenu', function (e) {
            debug('map contextmenu state.editMode=' + state.editMode);
            if (!state.editMode) return;
            debug('edit mode active - attempt delete by right-click');
            e.preventDefault();

            if (!state.map) {
                showError('Map not initialized.');
                return;
            }

            // Determine clicked LatLng
            let clickedLatLng = null;
            try {
                if (e && e.latlng) {
                    // If Leaflet provided latlng (when event originates from Leaflet)
                    clickedLatLng = e.latlng;
                } else if (e && e.originalEvent) {
                    // Compute container point from mouse client coordinates
                    const rect = document.getElementById('map').getBoundingClientRect();
                    const x = e.originalEvent.clientX - rect.left;
                    const y = e.originalEvent.clientY - rect.top;
                    clickedLatLng = state.map.containerPointToLatLng(L.point(x, y));
                }
            } catch (err) {
                console.error('Error determining clicked location:', err);
            }

            if (!clickedLatLng) {
                showError('Unable to determine clicked location on the map.');
                return;
            }

            // Get current polyline points
            let latlngs = [];
            if (state.polyline && typeof state.polyline.getLatLngs === 'function') {
                latlngs = state.polyline.getLatLngs();
            } else if (state.origLatLngs && state.origLatLngs.length) {
                latlngs = state.origLatLngs;
            }

            if (!latlngs || latlngs.length === 0) {
                showError('No track points available to delete.');
                return;
            }

            // Find nearest point index
            let nearestIdx = -1;
            let minDist = Infinity;
            for (let i = 0; i < latlngs.length; i++) {
                const ll = latlngs[i];
                if (!ll || typeof ll.distanceTo !== 'function') continue;
                const dist = clickedLatLng.distanceTo(ll); // meters
                if (dist < minDist) {
                    minDist = dist;
                    nearestIdx = i;
                }
            }

            if (nearestIdx === -1) {
                showError('No nearby track point found to delete.');
                return;
            }

            // Ask for confirmation. If click is not very close, warn the user.
            //const distanceMeters = Math.round(minDist);
            //let confirmMsg = 'Are you sure you want to delete track point #' + nearestIdx + '?';
            //if (distanceMeters > 30) {
            //    confirmMsg = 'Closest track point is #' + nearestIdx + ' (about ' + distanceMeters + ' m away). Delete this point? This action cannot be undone.';
            //}
            //if (!confirm(confirmMsg)) return;

            // Update slider to reflect selected index and trigger input so UI updates
            try {
                $('#timeSlider').val(nearestIdx).trigger('input');
            } catch (ignore) { /* ignore if slider not present */ }

            const removed = window.GpxFixMap.removeTrackPoint(nearestIdx);
            if (removed) {
                showMessage('Track point deleted.', '');
                // Refresh UI and chart
                const newIdx = Math.min(nearestIdx, Math.max(0, (state.coordinates ? state.coordinates.length - 1 : 0)));
                printCoordinateInfo(newIdx);
                moveVerticalLineTo(newIdx);
                initializeChart(state, 1);
                updateActivityInfo();
                showDownloadPanel();

                // Ensure edit markers remain visible and draggable so user can continue editing
                try {
                    state.editMode = true;

                    // Re-enable editing on polyline if method available
                    if (state.polyline) {
                        if (typeof state.polyline.enableEdit === 'function') {
                            try { state.polyline.enableEdit(); } catch (e) { /* ignore */ }
                        }
                        if (typeof state.polyline.editing === 'object' && typeof state.polyline.editing.enable === 'function') {
                            try { state.polyline.editing.enable(); } catch (e) { /* ignore */ }
                        }
                    }

                    // Recompute edit limits and reattach map drag listeners (plugin hook)
                    if (window.GpxFixMap && typeof window.GpxFixMap.setEditCoordinateLimits === 'function') {
                        try { window.GpxFixMap.setEditCoordinateLimits(); } catch (e) { /* ignore */ }
                    }
                    if (window.GpxFixMap && typeof window.GpxFixMap.attachDragListeners === 'function') {
                        try { window.GpxFixMap.attachDragListeners(); } catch (e) { /* ignore */ }
                    }

                    // Try to make internal edit markers visible and re-enable dragging across common plugin internal structures
                    const tryShowMarkers = function (poly) {
                        if (!poly) return;
                        try {
                            // common editors: poly.editor, poly.editing, poly._edit
                            const editors = [poly.editor, poly.editing, poly._edit];
                            let markers = null;
                            for (let ed of editors) {
                                if (!ed) continue;
                                markers = ed._markers || ed._markerGroup && (typeof ed._markerGroup.getLayers === 'function' ? ed._markerGroup.getLayers() : null) || ed._markersList || null;
                                if (markers) break;
                            }
                            if (!markers && poly._markers) markers = poly._markers;
                            if (markers && markers.length !== undefined) {
                                // markers may be an array or a Layer[] from _markerGroup.getLayers()
                                const arr = Array.isArray(markers) ? markers : markers;
                                arr.forEach(m => {
                                    try {
                                        if (m && m._icon && m._icon.style) m._icon.style.display = '';
                                        if (m && m.getElement) {
                                            const el = m.getElement && m.getElement();
                                            if (el && el.style) el.style.display = '';
                                        }
                                        if (m && m.dragging && typeof m.dragging.enable === 'function') {
                                            try { m.dragging.enable(); } catch (e) { /* ignore */ }
                                        }
                                    } catch (inner) { /* ignore per-marker errors */ }
                                });
                            }
                        } catch (ex) {
                            console.warn('Could not reveal edit markers:', ex);
                        }
                    };

                    tryShowMarkers(state.polyline);

                    // Update slider max / UI so further deletes/drags will use correct bounds
                    try { setupSlider(); } catch (e) { /* ignore */ }
                } catch (e) {
                    console.error('Error restoring edit markers after deletion:', e);
                }
            } else {
                showError('Failed to delete track point.');
            }
        });
    }

    $('#divSubmitEditsButton').click(function (e) {
        $('.leaflet-marker-icon').removeClass('highlight-marker');
        if (state.hasTimeCodes) {
            let editErr = window.GpxFixMap.hasCoordinatesEditError();
            if (editErr) {
                showError('Distance between points is too large.', 'See red markers. This indicates an unrealistic movement. Please reduce the distance between the modified points.');
                e.preventDefault();
                return;
            }
            //for (let i = 0; i < edits.length; i++) {
            //    let idx = parseInt(edits[i].index);
            //    let idxNext = idx + 1;
            //    let latlngs = polyline.getLatLngs();
            //    let editedCoord = latlngs[idx];
            //    let nextCoord = latlngs[idxNext];
            //    let dist = editedCoord.distanceTo(nextCoord);
            //    if (dist > maxAllowedDist) {
            //        showError('Distance between points is too large.', 'See red markers. This indicates an unrealistic movement. Please reduce the distance between each modified coordinates.</p>').show().delay(12000).fadeOut('slow');
            //        const marker = getMarkerByIndex(polyline, idx);
            //        debug('distance too far :indexes:' + idx + '-' + idxNext + ' dist:' + dist + ' maxalloweddist:' + maxAllowedDist);
            //        marker.getElement().classList.add('highlight-marker');
            //        const marker2 = getMarkerByIndex(polyline, idxNext);
            //        marker2.getElement().classList.add('highlight-marker');
            //        e.preventDefault();
            //        return;
            //    }
            //}
        }
        showLoader();
        //$('#fileUploadForm').attr('action', 'edit');
        // $('#trackChanges').val(JSON.stringify(edits));
        //$('#UploadState').val(1);
        debug('state.edits=');
        debug(state.edits);
        executeOperation('edit', { trackChanges: JSON.stringify(state.edits) });
        state.edits = [];
        state.editMode = false;
        $('#changesLeft').text('');
        $('#panel-submit-edits').hide();
    });


    $('#btEdit').on('click', function (e) {
        debug('btEdit');
        e.preventDefault();
        hideAllPanels();
        if (state.gpxXml === null) {
            showUploadFileMessage();
            return;
        }
        //debug(map.getZoom());
        if (state.map.getZoom() < 17) {
            //$('#mapOutput').html('<div class=\'error\'>Please zoom in on the map where you want to edit the track.</div>').show().delay(2000).fadeOut('slow');
            showError('Please zoom in on the map where you want to edit the track.');
            return;
        }
        // Initialize editing on the polyline first
        $('#message-bottom').hide();
        $('#panel-edit').show();
        state.polyline.enableEdit();
        state.editMode = true;

        window.GpxFixMap.attachDragListeners();

        //if (state.hasTimeCodes) //has timecodes
        $('#changesLeft').text('Drag map points to adjust your track. Too many coordinates to edit? Resample the track to reduce the number of points, or simply right-click a point to delete it.');
        //else
        //  $('#changesLeft').text('Drag map points. Activity has no time data so you are free to edit this track as you please without restrictions.');
    });

    // ---- Waypoint editing ----
    state.waypointEditMode = false;
    state.pendingWaypointChanges = [];

    function updateWptSaveButton() {
        if (state.pendingWaypointChanges && state.pendingWaypointChanges.length > 0) {
            $('#btn-wpt-save').show();
        } else {
            $('#btn-wpt-save').hide();
        }
        // Show the remove-all button only when waypoints exist to remove
        if (state.waypoints && state.waypoints.length > 0) {
            $('#btn-wpt-remove-all').show();
        } else {
            $('#btn-wpt-remove-all').hide();
        }
    }

    function renderWaypointList() {
        var html = '';
        if (state.waypoints && state.waypoints.length > 0) {
            // Build a sorted display order while preserving the original array indices
            // so edit/delete/highlight operations still work correctly.
            var sorted = state.waypoints.map(function (wpt, i) { return { i: i, wpt: wpt }; });

            // Regex matches an elevation token anywhere in the name, e.g. (2790m) or (2,790ft).
            // The numeric part may contain commas as thousands separators.
            var eleRegex = /\(([\d,]+)\s*(m|ft)\)/i;

            // Extract the numeric elevation value in metres from a name string.
            // Returns null if no elevation token is found.
            function parseElevation(name) {
                var m = eleRegex.exec(name || '');
                if (!m) return null;
                // Strip commas from the number before parsing
                var value = parseFloat(m[1].replace(/,/g, ''));
                var unit = m[2].toLowerCase();
                // Convert feet to metres so mixed units sort correctly
                return unit === 'ft' ? value * 0.3048 : value;
            }

            // If every waypoint title contains an elevation token, sort numerically by elevation.
            // Otherwise fall back to a simple case-insensitive alphabetical sort.
            var allHaveElevation = sorted.every(function (entry) {
                return parseElevation(entry.wpt.name) !== null;
            });

            if (allHaveElevation) {
                sorted.sort(function (a, b) {
                    return parseElevation(a.wpt.name) - parseElevation(b.wpt.name);
                });
            } else {
                sorted.sort(function (a, b) {
                    var na = (a.wpt.name || '').toLowerCase();
                    var nb = (b.wpt.name || '').toLowerCase();
                    return na < nb ? -1 : na > nb ? 1 : 0;
                });
            }

            sorted.forEach(function (entry) {
                var i = entry.i;
                var wpt = entry.wpt;
                var safeName = $('<span>').text(wpt.name || '').html();
                var safeDesc = $('<span>').text(wpt.desc || '').html();
                // data-index on the outer wpt-item lets highlight helpers target it by index
                html += '<div class="wpt-item" data-index="' + i + '" style="padding:4px 0;border-bottom:1px solid #ccc;">' +
                    '<div class="wpt-display" data-index="' + i + '">' +
                    '<b>' + (safeName || '(unnamed)') + '</b> ' +
                    '<small>Lat:' + wpt.lat.toFixed(5) + ' Lon:' + wpt.lon.toFixed(5) + ' <a href="https://www.google.com/maps?q=' + wpt.lat.toFixed(5) + ',' + wpt.lon.toFixed(5) + '" target="_blank">Google maps</a></small> ' +
                    ' <a href="#" class="btn-wpt-edit" data-index="' + i + '" style="margin-left:6px;">edit</a>' +
                    ' <a href="#" class="btn-wpt-delete" data-index="' + i + '" style="margin-left:6px;">delete</a>' +
                    '</div>' +
                    '<div class="wpt-edit-form" data-index="' + i + '" style="display:none;margin-top:4px;">' +
                    '<input type="text" class="input-wpt-edit-name" value="' + safeName + '" placeholder="Name" style="width:100%;margin-bottom:4px;" />' +
                    '<textarea class="input-wpt-edit-desc" placeholder="Description" style="width:100%;margin-bottom:4px;" rows="2">' + safeDesc + '</textarea>' +
                    '<button class="btn-wpt-edit-save" data-index="' + i + '">OK</button> ' +
                    '<button class="btn-wpt-edit-cancel" data-index="' + i + '">Cancel</button>' +
                    '</div>' +
                    '</div>';
            });
        } else {
            html = '<em>No waypoints. Click the map to add one.</em>';
        }
        $('#waypoint-list').html(html);
    }

    // Removes the wpt-highlighted class from every list row and the CSS highlight from every marker.
    function clearWaypointHighlights() {
        $('#waypoint-list .wpt-item').removeClass('wpt-highlighted');
        state.waypointMarkers.forEach(function (m) {
            if (m._icon) $(m._icon).removeClass('wpt-marker-highlight');
        });
    }

    // Highlights the list row and map marker for the given index,
    // scrolls the row into view, and clears any previous highlight first.
    function highlightWaypoint(idx) {
        clearWaypointHighlights();
        // Highlight the list row
        var $row = $('#waypoint-list .wpt-item[data-index="' + idx + '"]');
        $row.addClass('wpt-highlighted');
        // Scroll it into view inside the panel without moving the page
        if ($row[0]) $row[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        // Highlight the map marker icon
        var marker = state.waypointMarkers[idx];
        if (marker && marker._icon) $(marker._icon).addClass('wpt-marker-highlight');
    }

    function onMapClickTrack(e) {
        if (state.editMode || state.waypointEditMode) return;
        if (!state.polyline) return;
        var latlngs = state.polyline.getLatLngs();
        var idx = window.GpxFixMap.findNearestTrackIndex(e.latlng, latlngs);
        if (idx < 0) return;
        $('#timeSlider').val(idx).trigger('input');
    }

    function onMapClickWaypoint(e) {
        if (!state.waypointEditMode) return;
        var lat = e.latlng.lat;
        var lon = e.latlng.lng;
        // Remove any previous pending marker before placing a new one
        if (state._pendingWaypointMarker) {
            state.map.removeLayer(state._pendingWaypointMarker);
            state._pendingWaypointMarker = null;
        }
        // Show a temporary marker immediately at the clicked location
        state._pendingWaypointMarker = L.marker([lat, lon], {
            icon: window.GpxFixMap.makeWaypointIcon(state.map.getZoom()),
            opacity: 0.6
        }).addTo(state.map);
        $('#waypoint-add-coords').text(lat.toFixed(5) + ', ' + lon.toFixed(5));
        $('#input-wpt-name').val('');
        $('#input-wpt-desc').val('');
        $('#waypoint-add-form').data('lat', lat).data('lon', lon).show();
    }

    // Attaches all interaction listeners (drag, click-highlight, hover popup) to a single
    // waypoint marker. idx is the index into state.waypoints / state.waypointMarkers.
    function attachWaypointMarkerHandlers(marker, idx) {
        // Remove any previously registered listeners to avoid duplicates on re-entry
        marker.off('dragend click mouseover mouseout');

        // Drag — record the new position as an edit change
        marker.on('dragend', function () {
            var latlng = marker.getLatLng();
            var lat = latlng.lat;
            var lon = latlng.lng;
            if (state.waypoints[idx]) {
                state.waypoints[idx].lat = lat;
                state.waypoints[idx].lon = lon;
            }
            state.pendingWaypointChanges.push({ action: 'edit', index: idx, lat: lat, lon: lon });
            updateWptSaveButton();
            renderWaypointList();
            // Re-apply highlight after the list is rebuilt
            highlightWaypoint(idx);
        });

        // Click — highlight the corresponding list row
        marker.on('click', function () {
            highlightWaypoint(idx);
        });

        // Hover — open popup on mouseover, close it on mouseout so no click is needed
        marker.on('mouseover', function () {
            marker.openPopup();
        });
        marker.on('mouseout', function () {
            marker.closePopup();
        });
    }

    // Makes all current waypoint markers draggable and wires their interaction handlers.
    function enableWaypointDragging() {
        state.waypointMarkers.forEach(function (marker, idx) {
            marker.dragging && marker.dragging.enable();
            attachWaypointMarkerHandlers(marker, idx);
        });
    }

    // Removes dragging and interaction listeners from all current waypoint markers.
    function disableWaypointDragging() {
        state.waypointMarkers.forEach(function (marker) {
            marker.off('dragend click mouseover mouseout');
            marker.dragging && marker.dragging.disable();
        });
        clearWaypointHighlights();
    }

    // When editwaypoints panel is shown, enable waypoint edit mode
    $(document).on('panelShown', function (e, panelId) {
        if (panelId === 'editwaypoints') {
            state.waypointEditMode = true;
            state.pendingWaypointChanges = [];
            updateWptSaveButton();
            renderWaypointList();
            state.map.on('click', onMapClickWaypoint);
            // Allow existing waypoint markers to be repositioned by dragging
            enableWaypointDragging();
        }
    });

    $('#btn-wpt-add-confirm').on('click', function () {
        var lat = parseFloat($('#waypoint-add-form').data('lat'));
        var lon = parseFloat($('#waypoint-add-form').data('lon'));
        var name = $('#input-wpt-name').val() || '';
        var desc = $('#input-wpt-desc').val() || '';
        state.pendingWaypointChanges.push({ action: 'add', lat: lat, lon: lon, name: name, desc: desc });
        updateWptSaveButton();
        // Add to local waypoints for display
        if (!state.waypoints) state.waypoints = [];
        state.waypoints.push({ lat: lat, lon: lon, name: name, desc: desc });
        // Remove the temporary pending marker and replace it with a full-opacity permanent one
        if (state._pendingWaypointMarker) {
            state.map.removeLayer(state._pendingWaypointMarker);
            state._pendingWaypointMarker = null;
        }
        var marker = L.marker([lat, lon], {
            icon: window.GpxFixMap.makeWaypointIcon(state.map.getZoom()),
            draggable: true
        }).addTo(state.map);
        if (name || desc) marker.bindPopup('<b>' + name + '</b><br>' + desc);
        state.waypointMarkers.push(marker);
        // Wire all interaction handlers (drag, click-highlight, hover popup) for the new marker
        attachWaypointMarkerHandlers(marker, state.waypointMarkers.length - 1);
        $('#waypoint-add-form').hide();
        renderWaypointList();
    });

    $('#btn-wpt-add-cancel').on('click', function () {
        // Remove the temporary pending marker when the user cancels
        if (state._pendingWaypointMarker) {
            state.map.removeLayer(state._pendingWaypointMarker);
            state._pendingWaypointMarker = null;
        }
        $('#waypoint-add-form').hide();
    });

    $(document).on('click', '.btn-wpt-edit', function (e) {
        e.preventDefault();
        var idx = parseInt($(this).data('index'));
        $('.wpt-edit-form').hide();
        $('.wpt-edit-form[data-index="' + idx + '"]').show();
        // Highlight the marker on the map and pan to it so the user can see which one they are editing
        highlightWaypoint(idx);
        var marker = state.waypointMarkers[idx];
        if (marker && state.map) state.map.panTo(marker.getLatLng());
    });

    $(document).on('click', '.btn-wpt-edit-save', function () {
        var idx = parseInt($(this).data('index'));
        var form = $('.wpt-edit-form[data-index="' + idx + '"]');
        var name = form.find('.input-wpt-edit-name').val() || '';
        var desc = form.find('.input-wpt-edit-desc').val() || '';
        state.pendingWaypointChanges.push({ action: 'edit', index: idx, name: name, desc: desc });
        state.waypoints[idx].name = name;
        state.waypoints[idx].desc = desc;
        if (state.waypointMarkers[idx]) {
            // Use the helper function to build popup content that includes images from links
            var popupContent = window.GpxFixMap.buildWaypointPopupContent(state.waypoints[idx]);
            state.waypointMarkers[idx].setPopupContent(popupContent);
        }
        updateWptSaveButton();
        renderWaypointList();
    });

    $(document).on('click', '.btn-wpt-edit-cancel', function () {
        var idx = parseInt($(this).data('index'));
        $('.wpt-edit-form[data-index="' + idx + '"]').hide();
    });

    $(document).on('click', '.btn-wpt-delete', function (e) {
        e.preventDefault();
        var idx = parseInt($(this).data('index'));
        state.pendingWaypointChanges.push({ action: 'delete', index: idx });
        // Remove marker from map
        if (state.waypointMarkers[idx]) {
            state.map.removeLayer(state.waypointMarkers[idx]);
        }
        state.waypoints.splice(idx, 1);
        state.waypointMarkers.splice(idx, 1);
        // Update buttons after splice so remove-all visibility reflects the new waypoint count
        updateWptSaveButton();
        renderWaypointList();
    });

    $('#btn-wpt-save').on('click', function () {
        if (state.pendingWaypointChanges.length === 0) {
            showError('No waypoint changes to save.');
            return;
        }
        // Discard any pending marker that was not confirmed before saving
        if (state._pendingWaypointMarker) {
            state.map.removeLayer(state._pendingWaypointMarker);
            state._pendingWaypointMarker = null;
        }
        disableWaypointDragging();
        state.map.off('click', onMapClickWaypoint);
        state.waypointEditMode = false;
        executeOperation('editwaypoints', { waypointChanges: state.pendingWaypointChanges });
        state.pendingWaypointChanges = [];
        updateWptSaveButton();
    });

    // Queues a delete change for every waypoint, removes their map markers, then prompts the user to save
    $('#btn-wpt-remove-all').on('click', function () {
        if (!state.waypoints || state.waypoints.length === 0) return;
        // Queue a delete for each index in descending order (matches server-side processing)
        for (var i = state.waypoints.length - 1; i >= 0; i--) {
            state.pendingWaypointChanges.push({ action: 'delete', index: i });
        }
        // Remove all markers from the map
        state.waypointMarkers.forEach(function (marker) {
            state.map.removeLayer(marker);
        });
        state.waypoints = [];
        state.waypointMarkers = [];
        updateWptSaveButton();
        renderWaypointList();
    });

    function handleAction(action) {
        if (!state.gpxXml) {
            showUploadFileMessage();
            return;
        }
        if (action == 'edit') //these operations have separate handling
            return;

        // Check time data for time-related operations
        if (['reducetime', 'increasetime', 'changeelapsedtime', 'movingtime', 'removestilltime'].includes(action) && !state.hasTime) {
            showError('This workout does not have timestamp data.');
            return;
        }
        scrollToBottomMessage();
        // Check HR data for HR operations
        if (action === 'fixhr' && !state.hasHeartRate) {
            showError('This workout does not contain heart rate data.');
            return;
        }

        // Actions that need user input - show panel
        const panelActions = ['changeelapsedtime', 'changedate', 'calibrateelevation', 'crop', 'updatedistance', 'compare', 'combine', 'edit', 'restoremissinggps', 'resample', 'fixhr', 'fixgps', 'strip', 'editwaypoints', 'smoothengps'];

        if (panelActions.includes(action)) {
            showPanel(action);
            // When opening the 'Change time' panel, pre-populate the at-point sub-panel
            // with data for whichever track point the slider is currently on.
            if (action === 'changedate') {
                refreshChangeDateAtPointInfo();
            }
            return;
        }

        // Immediate actions
        executeOperation(action);
    }

    function getCurrentSportType() {
        return state.summary?.sportType || state.activityMetadata?.sportType || '';
    }

    /**
     * Updates (or inserts) the {@code <type>} element inside the first {@code <trk>} block
     * of a GPX XML string and returns the modified XML.
     * Strava reads this element to determine the activity type when importing a GPX file.
     * @param {string} gpxXml - The full GPX XML string to modify.
     * @param {string} newType - The new sport/activity type value (e.g. 'Run', 'Ride').
     * @returns {string} The updated GPX XML string.
     */
    function updateGpxSportType(gpxXml, newType) {
        if (!gpxXml || !newType) return gpxXml;
        try {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(gpxXml, 'application/xml');

            // Guard against malformed XML
            const parseError = xmlDoc.querySelector('parsererror');
            if (parseError) {
                console.warn('updateGpxSportType: could not parse GPX XML');
                return gpxXml;
            }

            // Find the first <trk> element (namespace-agnostic)
            const trkElements = xmlDoc.getElementsByTagName('trk');
            if (trkElements.length === 0) return gpxXml;

            const trk = trkElements[0];

            // Try to find an existing <type> child element within <trk>
            let typeEl = null;
            for (let i = 0; i < trk.childNodes.length; i++) {
                const node = trk.childNodes[i];
                if (node.nodeType === Node.ELEMENT_NODE && node.localName === 'type') {
                    typeEl = node;
                    break;
                }
            }

            if (typeEl) {
                // Update the existing <type> element
                typeEl.textContent = newType;
            } else {
                // Insert a new <type> element before the first <trkseg>, or at the end of <trk>
                const typeNode = xmlDoc.createElementNS(trk.namespaceURI, 'type');
                typeNode.textContent = newType;
                const trkseg = trk.getElementsByTagName('trkseg')[0];
                if (trkseg) {
                    trk.insertBefore(typeNode, trkseg);
                } else {
                    trk.appendChild(typeNode);
                }
            }

            return new XMLSerializer().serializeToString(xmlDoc);
        } catch (err) {
            console.warn('updateGpxSportType error:', err);
            return gpxXml;
        }
    }

    function getSelectedSportTypeForSave() {
        const selectedSportType = $('#select-sport-type').val() || '';
        return selectedSportType || getCurrentSportType() || 'Run';
    }

    function populateSportTypeDropdown() {
        const $dropdown = $('#select-sport-type');
        if ($dropdown.length === 0) return;

        // Preserve any type the user may have already selected before this repopulation
        const selectedSportType = $dropdown.val() || getCurrentSportType();
        $dropdown.empty();

        $dropdown.append($('<option>', { value: '', text: '-- Keep original --' }));

        outdoorActivityTypes.forEach(function (typeName) {
            $dropdown.append($('<option>', { value: typeName, text: typeName }));
        });

        if (selectedSportType && $dropdown.find('option').filter(function () { return this.value === selectedSportType; }).length > 0) {
            $dropdown.val(selectedSportType);
        } else {
            $dropdown.val('');
        }
    }

    // ---- News bulletin: visibility and dismissal logic ----
    // The bulletin starts as display:none in the HTML.
    // It is shown only to returning visitors (users who have loaded the page at least once before).
    // When a user closes it, the bulletin's current data-id is stored in localStorage so it
    // stays hidden until the data-id attribute on the element is incremented to a new value.
    function initNewsBulletin() {
        // localStorage key used to track dismissal
        const DISMISSED_KEY = 'gpxfix_bulletin_dismissed';

        const $bulletin = $('#news-bulletin');
        if ($bulletin.length === 0) return;

        const bulletinId = String($bulletin.data('id'));
        const dismissedId = localStorage.getItem(DISMISSED_KEY);

        // Only show the bulletin if its ID has not been dismissed.
        if (dismissedId !== bulletinId) {
            $bulletin.show();
        }

        // Wire up the close button: persist the dismissed id and hide the banner.
        $('#btn-close-bulletin').on('click', function () {
            localStorage.setItem(DISMISSED_KEY, bulletinId);
            $bulletin.hide();
        });
    }

    // Initialize
    $(document).ready(function () {
        debug('spa.js document.ready');
        initNewsBulletin();
        setupEventHandlers();
    });
})();


